import 'dayjs/locale/fr';
import { useNavigate } from 'react-router-dom';
import { useParams, useSearchParams } from "react-router-dom";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import axios from "axios";
import Base64 from 'crypto-js/enc-base64';
import Button from '@mui/material/Button';
import CallIcon from '@mui/icons-material/Call';
import CONFIG from '../../../config';
import dayjs from 'dayjs';
import EuroIcon from '@mui/icons-material/Euro';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import GroupsIcon from '@mui/icons-material/Groups';
import HomeIcon from '@mui/icons-material/Home';
import Link from '@mui/material/Link';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import React from 'react';
import sha256 from 'crypto-js/sha256';
import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import WidgetDatePicker from '../../../components/widgets/WidgetDatePicker';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetInputTextList from '../../../components/widgets/WidgetInputTextList';
import WidgetProgress from '../../../components/widgets/WidgetProgress';
import WidgetSelect from '../../../components/widgets/WidgetSelect';
import WorkIcon from '@mui/icons-material/Work';
import FicheInfo from './FicheInfo';
import Questionnaire from '../../client/questionnaire/Questionnaire';
import Dossier from '../../client/dossier/Dossier';
import FicheDocuments from './FicheDocuments';
import WidgetInputVille from '../../../components/widgets/WidgetInputVille';
import WidgetDropZone from '../../../components/widgets/WidgetDropZone';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Divider, IconButton, Tab, Tabs } from '@mui/material';
import DocumentState from '../../client/dossier/DocumentState';
import FicheWidgetCommercial from './FicheWidgetCommercial';
import WidgetFile from '../../../components/widgets/WidgetFile';
import Dropzone from 'react-dropzone';
import FicheAdmin from './FicheAdmin';
import QuestionnaireLocataire from '../../client/questionnaire_locataire/QuestionnaireLocataire';
import QuestionnaireGarant from '../../client/questionnaire_garant/QuestionnaireGarant';
import FicheMetaGroupDocuments from './FicheMetaGroupDocuments';
import FolderIcon from '@mui/icons-material/Folder';
import SavingsIcon from '@mui/icons-material/Savings';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FicheEtatDossier from './FicheEtatDossier';
import FicheEtatDossierLoc from './FicheEtatDossierLoc';
import FicheEtatDossierGarant from './FicheEtatDossierGarant';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import WidgetSnackbar from '../../../components/widgets/WidgetSnackbar';
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import WidgetAlertbox from '../../../components/widgets/WidgetAlertbox';


const getDocument = (user, type_dossier, document_name) => {
  var document = null;

  if (type_dossier == 'deuxieme_locataire') {
    document = user.dossier.deuxieme_locataire.documents[document_name];
  } else if (type_dossier == 'dossier') {
    document = user.dossier.documents[document_name];
  } else {
    document = user.dossier.list_garants[type_dossier].documents[document_name];
  }

  return document
};


function Fiche({ current }) {
  const navigate = useNavigate();

  const [snackPropose, openSnackPropose] = WidgetSnackbar("Proposition(s) envoyée(s)");
  const [snackAttribut, openSnackAttribut] = WidgetSnackbar("Attribution effectuée");
  const [snackDesAttribut, openSnackDesAttribut] = WidgetSnackbar("Attribution retirée");
  const [snackValide, openSnackValide] = WidgetSnackbar("Client validé");
  const [snackMailcrea, openSnackMailcrea] = WidgetSnackbar("Mail envoyé");
  const [snackMailOrga, openSnackMailOrga] = WidgetSnackbar("Dossier noté comme envoyé (mail-auto désactivé)");
  const [snackUpdatedNote, openSnackUpdatedNote] = WidgetSnackbar("Complément synchronisé");
  const [snackRole, openSnackRole] = WidgetSnackbar("Roles mis à jour");
  const [snackFacture, openSnackFacture] = WidgetSnackbar("Facture mise à jour");
  const [snackMontant, openSnackMontant] = WidgetSnackbar("Comptabilité mise à jour");

  const [roleClient, setRoleClient] = React.useState(null);
  const [roleCommercial, setRoleCommercial] = React.useState(null);
  const [roleLecture, setRoleLecture] = React.useState(null);
  const [roleEcriture, setRoleEcriture] = React.useState(null);
  const [roleComptabilite, setRoleComptabilite] = React.useState(null);

  const { id } = useParams();
  const [user, setUser] = React.useState(null);
  const [nbCommerciauxSecteur, setNbCommerciauxSecteur] = React.useState(0);
  const [typeFacture, setTypeFacture] = React.useState(null);
  const [commerciaux, setCommerciaux] = React.useState(null);
  const [commercialAttribution, setCommercialAttribution] = React.useState(null);
  const [commerciauxProposition, setCommerciauxProposition] = React.useState(null);
  const [secteurProposition, setSecteurProposition] = React.useState(null);
  const [messageQuestionnaire, setMessageQuestionnaire] = React.useState(null);
  const [message, setMessage] = React.useState(null);
  const [complementAdmin, setComplementAdmin] = React.useState(null);
  const [complementCommercial, setComplementCommercial] = React.useState(null);

  var formList = [];
  const pushReturn = (array, item) => { array.push(item); return item; };
  const [adresse1, setAdresse1] = pushReturn(formList, React.useState(null));
  const [codePostal1, setCodePostal1] = pushReturn(formList, React.useState(null));
  const [ville1, setVille1] = pushReturn(formList, React.useState(null));
  const [pays1, setPays1] = pushReturn(formList, React.useState(null));

  const [adresse2, setAdresse2] = pushReturn(formList, React.useState(null));
  const [codePostal2, setCodePostal2] = pushReturn(formList, React.useState(null));
  const [ville2, setVille2] = pushReturn(formList, React.useState(null));
  const [pays2, setPays2] = pushReturn(formList, React.useState(null));

  const [adresse3, setAdresse3] = pushReturn(formList, React.useState(null));
  const [codePostal3, setCodePostal3] = pushReturn(formList, React.useState(null));
  const [ville3, setVille3] = pushReturn(formList, React.useState(null));
  const [pays3, setPays3] = pushReturn(formList, React.useState(null));

  const [date1, setDate1] = pushReturn(formList, React.useState(null));
  const [date2, setDate2] = pushReturn(formList, React.useState(null));

  const [facture, setFacture] = pushReturn(formList, React.useState(null));

  const [montant, setMontant] = pushReturn(formList, React.useState(null));
  const [presta, setPresta] = pushReturn(formList, React.useState(null));
  const [datePaiementOrganisme, setDatePaiementOrganisme] = pushReturn(formList, React.useState(null));
  const [datePaiementCommercial, setDatePaiementCommercial] = pushReturn(formList, React.useState(null));
  const [datePaiementCodePromo, setDatePaiementCodePromo] = pushReturn(formList, React.useState(null));


  const [currentPage, setCurrentPage] = React.useState(0);
  const [currentSubPage, setCurrentSubPage] = React.useState(0);
  const handleChangeTab = (_, newValue) => {
    setCurrentPage(newValue);
    setCurrentSubPage(0);
  };
  const handleChangeSubTab = (_, newValue) => {
    setCurrentSubPage(newValue);
  };

  React.useEffect(() => {
    setMessageQuestionnaire((s) => ({ ...s, value: "", error: false }));
  }, [currentPage, currentSubPage])


  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_client/' + id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setUser(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }, []);


  const dayjs = require('dayjs');
  const duration = require('dayjs/plugin/duration');
  dayjs.extend(duration);

  const [clicked, setClicked] = React.useState(!!user?.date_suppression);
  React.useEffect(() => {
    setClicked(!!user?.date_suppression);
  }, [user]);
  var { days, hours, minutes } = ["", "", ""];

  if (clicked && user !== null) {
    const duration = dayjs.duration(dayjs(user?.date_suppression).diff(dayjs()));
    days = duration.days();
    hours = duration.hours();
    minutes = duration.minutes();
  }

  const [alertDelete, openAlertDelete] = WidgetAlertbox("Êtes-vous sûr(e) de vouloir supprimer ce compte ? Cette action prendra effet dans un délai de 30 jours.");


  if (current.roles.role_admin_write && user !== null && commerciaux === null) {
    axios.get(CONFIG.API_URL + '/api/get_all_commercial', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            var temp_commerciaux = {};

            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].nom.trim() === '' && response.data[i].prenom.trim() === '')
                temp_commerciaux[response.data[i]._id] = 'Sans nom (' + response.data[i]._id + ')';
              else
                temp_commerciaux[response.data[i]._id] = response.data[i].nom + ' ' + response.data[i].prenom;
              if (user !== null && response.data[i].informations_admin.secteur === user.dossier.secteur_recherche)
                setNbCommerciauxSecteur(x => x + 1);
            }

            setCommerciaux(temp_commerciaux);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }


  return (
    <>
      {snackPropose}
      {snackAttribut}
      {snackDesAttribut}
      {snackValide}
      {snackMailcrea}
      {snackMailOrga}
      {snackUpdatedNote}
      {snackRole}
      {snackFacture}
      {snackMontant}
      {alertDelete}
      {user !== null &&
        (
          <>
            {user.roles.role_client &&
              <>
                <div className='w-full'>
                  <div className='bg-gray-100 my-shadow m-6'>
                    <div className='grid grid-cols-12 gap-x-4 mt-6 mb-6 px-6'>
                      <div className='col-span-12 w-full text-center mb-4'>
                        <h1>Informations importantes</h1>
                        (Utilisateur : {user._id})
                        {user.dossier.id_commercial !== null && commerciaux !== null && <><br></br>(Commercial : {commerciaux[user.dossier.id_commercial]})</>}
                        <br></br>
                        (Facturation : {user.dossier.type_facturation})
                        <br></br>
                        (Acquisition : {
                          ((user.dossier.type_acquisition === 'recommendation') ? 'Recommendation' :
                            ((user.dossier.type_acquisition === 'bouche_oreille') ? 'Bouche à oreille' :
                              ((user.dossier.type_acquisition === 'partenariat_ecole') ? 'Partenariat école' :
                                ((user.dossier.type_acquisition === 'partenariat_entreprise') ? 'Partenariat entreprise' :
                                  ((user.dossier.type_acquisition === 'telephone') ? 'Téléphone' :
                                    ((user.dossier.type_acquisition === 'flyers') ? 'Flyers' :
                                      ((user.dossier.type_acquisition === 'salon') ? 'Salon' :
                                        ((user.dossier.type_acquisition === 'vitrine') ? 'Vitrine' :
                                          ((user.dossier.type_acquisition === 'google') ? 'Google' :
                                            ((user.dossier.type_acquisition === 'facebook') ? 'Facebook' :
                                              ((user.dossier.type_acquisition === 'linkedin') ? 'LinkedIn' :
                                                ((user.dossier.type_acquisition === 'instagram') ? 'Instagram' : 'Autre...'))))))))))))
                        })
                        <br></br>
                        (Code promo : {(user.dossier.code_promo === '') ? '- ' : user.dossier.code_promo})
                      </div>

                      <div className='col-span-4 w-full text-left'>
                        <h2>Locataire n°1</h2>
                        {(current.roles.role_admin_read || current.roles.role_admin_write || (user.dossier.id_commercial !== null && user.dossier.id_commercial === current._id)) &&
                          <>
                            <h3>Informations de contact</h3>
                            Nom prénom : {user.nom} {user.prenom}
                            <br></br>
                            Email : {user.email}
                            <br></br>
                            Téléphone : {user.telephone}
                            <br></br>
                            <br></br>
                          </>
                        }

                        <h3>Situation</h3>
                        Revenus net : {user.dossier.revenu_net + " €"}
                        <br></br>
                        Type de contrat : {user.dossier.type_contrat}
                        <br></br>
                        Avec période d'essai : {user.dossier.avec_essai ? 'oui' : 'non'}
                        <br></br>
                        Avec mutation : {user.dossier.mute ? 'oui' : 'non'}
                        <br></br>
                        Situation matrimoniale : {{
                          'celibataire': "Célibataire",
                          'union': "Union libre",
                          'pacse': "Pacsé",
                          'marie': "Marié",
                          'serpare': "Séparé",
                          'divorce': "Divorcé",
                          'veuf': "Veuf"
                        }[user.dossier.situation_matrimoniale]}
                        <br></br>
                        Enfants à charge : {user.dossier.nombre_enfant}
                        <br></br>
                        Autres personnes à charge : {user.dossier.nombre_autres_charge}
                        <br></br>
                        Rattaché fiscalement : {user.dossier.ratache_fiscalement ? 'oui' : 'non'}
                        <br></br>
                        <br></br>

                        {user.dossier.avec_deuxieme_locataire &&
                          <>
                            <h2>Locataire n°2</h2>
                            {(current.roles.role_admin_read || current.roles.role_admin_write || (user.dossier.id_commercial !== null && user.dossier.id_commercial === current._id)) &&
                              <>
                                <h3>Informations de contact</h3>
                                Nom prénom : {user.dossier.deuxieme_locataire.nom} {user.dossier.deuxieme_locataire.prenom}
                                <br></br>
                                Email : {user.dossier.deuxieme_locataire.email}
                                <br></br>
                                Téléphone : {user.dossier.deuxieme_locataire.telephone}
                                <br></br>
                                <br></br>
                              </>
                            }

                            <h3>Situation</h3>
                            Revenus net : {user.dossier.deuxieme_locataire.revenu_net + " €"}
                            <br></br>
                            Situation professionnelle : {{
                              'salarie': "Salarié",
                              'publique': "Fonctionnaire",
                              'tns': "Chef d'entreprise/indépendant",
                              'retraite': "Retraité",
                              'sans_emploi': "Sans emploi",
                              'etudiant': "Etudiant",
                            }[user.dossier.deuxieme_locataire.situation_professionnelle]}
                            <br></br>
                            En période d'essai : {user.dossier.deuxieme_locataire.en_essai ? 'oui' : 'non'}
                            <br></br>
                            Situation matrimoniale : {{
                              'celibataire': "Célibataire",
                              'union': "Union libre",
                              'pacse': "Pacsé",
                              'marie': "Marié",
                              'serpare': "Séparé",
                              'divorce': "Divorcé",
                              'veuf': "Veuf"
                            }[user.dossier.deuxieme_locataire.situation_matrimoniale]}
                            <br></br>
                            Rattaché fiscalement : {user.dossier.deuxieme_locataire.ratache_fiscalement ? 'oui' : 'non'}
                            <br></br>
                            Logement actuel : {{
                              'locataire': "Locataire",
                              'proprietaire': "Propriétaire",
                              'heberge': "Hebergé"
                            }[user.dossier.deuxieme_locataire.type_logement_actuel]}
                            <br></br>
                            <br></br>
                          </>
                        }
                      </div>

                      <div className='col-span-4 w-full text-left'>
                        {user.dossier.list_garants.map((g, i) => (
                          <>
                            <h2>Garant n°{i + 1}</h2>
                            {(current.roles.role_admin_read || current.roles.role_admin_write || (user.dossier.id_commercial !== null && user.dossier.id_commercial === current._id)) &&
                              <>
                                <h3>Informations de contact</h3>
                                Nom prénom : {g.nom} {g.prenom}
                                <br></br>
                                Email : {g.email}
                                <br></br>
                                Téléphone : {g.telephone}
                                <br></br>
                                <br></br>
                              </>
                            }

                            <h3>Situation</h3>
                            Revenus net : {g.revenu_net + " €"}
                            <br></br>
                            Situation professionnelle : {{
                              'salarie': "Salarié",
                              'publique': "Fonctionnaire",
                              'tns': "Chef d'entreprise/indépendant",
                              'retraite': "Retraité",
                              'sans_emploi': "Sans emploi",
                              'etudiant': "Etudiant",
                            }[g.situation_professionnelle]}
                            <br></br>
                            En période d'essai : {g.en_essai ? 'oui' : 'non'}
                            <br></br>
                            Situation matrimoniale : {{
                              'celibataire': "Célibataire",
                              'union': "Union libre",
                              'pacse': "Pacsé",
                              'marie': "Marié",
                              'serpare': "Séparé",
                              'divorce': "Divorcé",
                              'veuf': "Veuf"
                            }[g.situation_matrimoniale]}
                            <br></br>
                            Rattaché fiscalement : {g.ratache_fiscalement ? 'oui' : 'non'}
                            <br></br>
                            Logement actuel : {{
                              'locataire': "Locataire",
                              'proprietaire': "Propriétaire",
                              'heberge': "Hebergé"
                            }[g.type_logement_actuel]}
                            <br></br>
                            <br></br>
                          </>
                        )
                        )}
                      </div>

                      <div className='col-span-4 w-full text-left'>
                        <h2>Bien recherché</h2>

                        <h3>Secteur</h3>
                        Secteur de recherche : {capitalizeFirstLetter(user.dossier.secteur_recherche)} {user.dossier.secteur_recherche_precision !== '' ? ('(' + user.dossier.secteur_recherche_precision + ')') : ''}
                        <br></br>
                        Villes de recherche :
                        <ul className='list-disc list-inside'>
                          {user.dossier.villes_recherche.map(x => <li>{x}</li>)}
                        </ul>
                        <br></br>

                        <h3>Critères</h3>
                        Type d'appartement : {user.dossier.type_appartement_recherche.map(x => x + '; ')}
                        <br></br>
                        Meublé : {user.dossier.type_meuble === 'meuble' ? 'oui' : (user.dossier.type_meuble === 'non-meuble' ? 'non' : 'peu importe')}
                        <br></br>
                        Equipement(s) obligatoire(s) : {user.dossier.equipement_obligatoire.map(x => x + '; ')}
                        <br></br>
                        Equipement(s) optionnel(s) : {user.dossier.equipement_optionnel.map(x => x + '; ')}
                        <br></br>
                        Loyer maximum : {user.dossier.max_loyer + " €"}
                        <br></br>
                        Surface minimum : {user.dossier.min_surface + " m²"}
                        <br></br>
                        <br></br>

                        {/* {(current.roles.role_admin_read || current.roles.role_admin_write || (user.dossier.id_commercial !== null && user.dossier.id_commercial === current._id)) &&

                        } */}

                        {(current.roles.role_admin_read || current.roles.role_admin_write) && !user.email_verifie &&
                          <>
                            <h2 className='mb-2'>Création du compte</h2>

                            <Button variant='contained' disabled={user.email == ''} onClick={() => {
                              axios.post(CONFIG.API_URL + '/api/creation_compte_mail_client/' + user._id, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                .then((response) => {
                                  switch (response.status) {
                                    case 200:
                                      openSnackMailcrea();
                                      break;

                                    default:
                                      break;
                                  }
                                })
                                .catch((e) => {
                                  let response = e.response;

                                  if (response === undefined) {
                                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                    return;
                                  }

                                  switch (response.status) {
                                    default:
                                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                      break;
                                  }
                                });
                            }}>
                              Envoyer le mail de création
                            </Button>
                            <br></br>
                            <br></br>
                          </>
                        }

                        {(current.roles.role_admin_read || current.roles.role_admin_write || (user.dossier.id_commercial !== null && user.dossier.id_commercial === current._id)) &&
                          <>
                            <h2 className='mb-2'>Documents</h2>

                            <Button variant='contained' onClick={() => {
                              axios.get(CONFIG.API_URL + '/api/client_download_dossier/' + user._id, { responseType: 'blob', headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token'), 'Cache-Control': 'no-cache' } })
                                .then((response) => {
                                  switch (response.status) {
                                    case 200:
                                      // create file link in browser's memory
                                      const href = URL.createObjectURL(response.data);

                                      // create "a" HTML element with href to file & click
                                      const link = document.createElement('a');
                                      link.href = href;
                                      link.setAttribute('download', user.nom + ' ' + user.prenom); //or any other extension
                                      document.body.appendChild(link);
                                      link.click();

                                      // clean up "a" element & remove ObjectURL
                                      document.body.removeChild(link);
                                      URL.revokeObjectURL(href);
                                      break;

                                    default:
                                      break;
                                  }
                                })
                                .catch((e) => {
                                  let response = e.response;

                                  if (response === undefined) {
                                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                    return;
                                  }

                                  switch (response.status) {
                                    default:
                                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                      break;
                                  }
                                });
                            }}>
                              Télécharger
                            </Button>
                          </>
                        }
                        <br></br>
                        <br></br>
                      </div>

                      {(current.roles.role_admin_read || current.roles.role_admin_write || (user.dossier.id_commercial !== null && user.dossier.id_commercial === current._id)) &&
                        <>
                          <div className='col-span-12 w-full text-right'>
                            <hr className='max-w-full mx-auto shrink-0 border-gray-400 p-4'></hr>
                          </div>

                          <div className='col-span-6 w-full text-right'>
                            <WidgetInputText state={complementCommercial} setState={setComplementCommercial} id={'complement_commercial'} text={"Complément"} multiline={true} value={user.dossier.complement_commercial} />
                            <Button variant='contained' onClick={() => {
                              axios.post(CONFIG.API_URL + '/api/set_note_commercial/' + user._id, { message: complementCommercial.value }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token'), 'Cache-Control': 'no-cache' } })
                                .then((response) => {
                                  switch (response.status) {
                                    case 200:
                                      setUser(response.data);
                                      openSnackUpdatedNote();
                                      break;

                                    default:
                                      break;
                                  }
                                })
                                .catch((e) => {
                                  let response = e.response;

                                  if (response === undefined) {
                                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                    return;
                                  }

                                  switch (response.status) {
                                    default:
                                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                      break;
                                  }
                                });
                            }}>
                              Mettre à jour
                            </Button>
                          </div>
                        </>
                      }

                      {(current.roles.role_admin_read || current.roles.role_admin_write) &&
                        <div className='col-span-6 w-full text-right'>
                          <WidgetInputText state={complementAdmin} setState={setComplementAdmin} id={'complement_admin'} text={"Complément (admin)"} multiline={true} value={user.dossier.complement_admin} />
                          <Button variant='contained' onClick={() => {
                            axios.post(CONFIG.API_URL + '/api/set_note_admin/' + user._id, { message: complementAdmin.value }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token'), 'Cache-Control': 'no-cache' } })
                              .then((response) => {
                                switch (response.status) {
                                  case 200:
                                    setUser(response.data);
                                    openSnackUpdatedNote();
                                    break;

                                  default:
                                    break;
                                }
                              })
                              .catch((e) => {
                                let response = e.response;

                                if (response === undefined) {
                                  alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                  return;
                                }

                                switch (response.status) {
                                  default:
                                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                    break;
                                }
                              });
                          }}>
                            Mettre à jour
                          </Button>
                        </div>
                      }
                    </div>
                  </div>

                  <div className='bg-gray-100 my-shadow m-6'>
                    <div className='grid grid-cols-12 gap-x-4 mt-6'>
                      <div className='col-span-12 w-full text-center mb-2'>
                        <h1>Panneau de contrôle client</h1>
                      </div>

                      <div className='col-span-12 w-full text-center mb-2 ml-6'>
                        <Tabs value={currentPage} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto">
                          <Tab label="Informations" id="simple-tab-0" disabled={!(current.roles.role_admin_read || current.roles.role_admin_write)} />
                          <Tab label="Documents" id="simple-tab-1" sx={{ borderRight: "1px solid gray" }} disabled={!(current.roles.role_admin_read || current.roles.role_admin_write)} />
                          <Tab label="Vérifier" id="simple-tab-2" disabled={!((current.roles.role_admin_read || current.roles.role_admin_write) && ['incomplet', 'complet', 'verifie', 'propose', 'attribue', 'valide'].includes(user.dossier.etat))} />
                          <Tab label="Attribuer" id="simple-tab-3" disabled={!((current.roles.role_admin_read || current.roles.role_admin_write) && ['verifie', 'propose', 'attribue'].includes(user.dossier.etat))} />
                          <Tab label="Valider" id="simple-tab-4" disabled={!(['attribue', 'valide'].includes(user.dossier.etat))} />
                          <Tab label="Envoyer" id="simple-tab-5" disabled={!(['valide', 'envoye'].includes(user.dossier.etat))} />
                          <Tab label="Archiver" id="simple-tab-6" disabled={!(['valide', 'envoye', 'archive'].includes(user.dossier.etat))} />
                        </Tabs>
                      </div>


                      {currentPage === 0 && (current.roles.role_admin_read || current.roles.role_admin_write) &&
                        <div className='col-span-12 w-full mx-auto shrink-0 bg-gray-50 my-shadow'>
                          <div className='grid grid-cols-12 gap-x-4 mt-6'>
                            <div className='col-span-12 w-full text-center mb-2'>
                              <h1>Informations</h1>
                            </div>
                            <div className='col-span-12 w-full text-center mb-2 ml-6'>
                              <Tabs value={currentSubPage} onChange={handleChangeSubTab} variant="scrollable" scrollButtons="auto">
                                <Tab label="Locataire n°1" id="simple-tab-0" />
                                <Tab label="Locataire n°2" id="simple-tab-1" disabled={!user.dossier.avec_deuxieme_locataire} />
                                {user.dossier.list_garants.map((e, i) => <Tab key={i} label={"Garant n°" + (i + 1)} id={"simple-tab-" + (i + 2)} />)}
                              </Tabs>
                            </div>

                            <div className='col-span-12 w-full mx-auto shrink-0 bg-white my-shadow'>
                              <div className='grid grid-cols-12 gap-x-4 mt-6'>
                                <div className='col-span-12 w-full'>
                                  {currentPage === 0 && currentSubPage === 0 &&
                                    <>
                                      <Questionnaire admin={true} current={user} setCurrent={setUser}></Questionnaire>
                                      <hr className='max-w-4xl mx-auto shrink-0 border-gray-400'></hr>
                                      <div className='col-span-12 max-w-4xl mx-auto mt-6'>
                                        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 py-6 px-6 bg-white my-shadow'>
                                          <div className='flex col-span-12 w-full text-center justify-between'>
                                            <div className='flex text-center items-center'>
                                              <div className='pr-4 w-48 text-start'>
                                                <h3>Questionnaire locataire n°1</h3>
                                              </div>

                                              <div className='pr-4 w-32 text-start'>
                                                <DocumentState etat={user.dossier.questionnaire_etat}></DocumentState>
                                              </div>
                                            </div>

                                            <div className='flex text-center items-center'>
                                              <div className='pr-2 w-96'>
                                                <WidgetInputText state={messageQuestionnaire} setState={setMessageQuestionnaire} id={'message'} text={"Commentaire"} size="small" value={user.dossier.questionnaire_message} />
                                              </div>

                                              <div className=''>
                                                <IconButton onClick={() => {
                                                  let payload = { 'message': messageQuestionnaire.value, 'rejet': true };
                                                  axios.post(CONFIG.API_URL + '/api/retour_questionnaire/' + user._id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                                    .then((response) => {
                                                      switch (response.status) {
                                                        case 200:
                                                          setUser(response.data);
                                                          break;

                                                        default:
                                                          break;
                                                      }
                                                    })
                                                    .catch((e) => {
                                                      let response = e.response;

                                                      if (response === undefined) {
                                                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                        return;
                                                      }

                                                      switch (response.status) {
                                                        default:
                                                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                          break;
                                                      }
                                                    });
                                                }}><CancelIcon className='text-red-500'></CancelIcon></IconButton>
                                              </div>

                                              <div className=''>
                                                <IconButton onClick={() => {
                                                  let payload = { 'message': messageQuestionnaire.value, 'rejet': false };
                                                  axios.post(CONFIG.API_URL + '/api/retour_questionnaire/' + user._id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                                    .then((response) => {
                                                      switch (response.status) {
                                                        case 200:
                                                          setUser(response.data);
                                                          break;

                                                        default:
                                                          break;
                                                      }
                                                    })
                                                    .catch((e) => {
                                                      let response = e.response;

                                                      if (response === undefined) {
                                                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                        return;
                                                      }

                                                      switch (response.status) {
                                                        default:
                                                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                          break;
                                                      }
                                                    });
                                                }}><CheckCircleIcon className='text-green-500'></CheckCircleIcon></IconButton>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  }
                                  {currentPage === 0 && currentSubPage === 1 &&
                                    <>
                                      <QuestionnaireLocataire admin={true} current={user} setCurrent={setUser}></QuestionnaireLocataire>
                                      <hr className='max-w-4xl mx-auto shrink-0 border-gray-400'></hr>
                                      <div className='col-span-12 max-w-4xl mx-auto mt-6'>
                                        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 py-6 px-6 bg-white my-shadow'>
                                          <div className='flex col-span-12 w-full text-center justify-between'>
                                            <div className='flex text-center items-center'>
                                              <div className='pr-4 w-48 text-start'>
                                                <h3>Questionnaire locataire n°2</h3>
                                              </div>

                                              <div className='pr-4 w-32 text-start'>
                                                <DocumentState etat={user.dossier.deuxieme_locataire.questionnaire_etat}></DocumentState>
                                              </div>
                                            </div>

                                            <div className='flex text-center items-center'>
                                              <div className='pr-2 w-96'>
                                                <WidgetInputText state={messageQuestionnaire} setState={setMessageQuestionnaire} id={'message'} text={"Commentaire"} size="small" value={user.dossier.deuxieme_locataire.questionnaire_message} />
                                              </div>

                                              <div className=''>
                                                <IconButton onClick={() => {
                                                  let payload = { 'message': messageQuestionnaire.value, 'rejet': true };
                                                  axios.post(CONFIG.API_URL + '/api/retour_locataire/' + user._id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                                    .then((response) => {
                                                      switch (response.status) {
                                                        case 200:
                                                          setUser(response.data);
                                                          break;

                                                        default:
                                                          break;
                                                      }
                                                    })
                                                    .catch((e) => {
                                                      let response = e.response;

                                                      if (response === undefined) {
                                                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                        return;
                                                      }

                                                      switch (response.status) {
                                                        default:
                                                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                          break;
                                                      }
                                                    });
                                                }}><CancelIcon className='text-red-500'></CancelIcon></IconButton>
                                              </div>

                                              <div className=''>
                                                <IconButton onClick={() => {
                                                  let payload = { 'message': messageQuestionnaire.value, 'rejet': false };
                                                  axios.post(CONFIG.API_URL + '/api/retour_locataire/' + user._id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                                    .then((response) => {
                                                      switch (response.status) {
                                                        case 200:
                                                          setUser(response.data);
                                                          break;

                                                        default:
                                                          break;
                                                      }
                                                    })
                                                    .catch((e) => {
                                                      let response = e.response;

                                                      if (response === undefined) {
                                                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                        return;
                                                      }

                                                      switch (response.status) {
                                                        default:
                                                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                          break;
                                                      }
                                                    });
                                                }}><CheckCircleIcon className='text-green-500'></CheckCircleIcon></IconButton>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  }
                                  {currentPage === 0 && currentSubPage > 1 &&
                                    <>
                                      <QuestionnaireGarant key={currentSubPage} admin={true} current={user} setCurrent={setUser} _id={currentSubPage - 2}></QuestionnaireGarant>
                                      <hr className='max-w-4xl mx-auto shrink-0 border-gray-400'></hr>
                                      <div className='col-span-12 max-w-4xl mx-auto mt-6'>
                                        <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 py-6 px-6 bg-white my-shadow'>
                                          <div className='flex col-span-12 w-full text-center justify-between'>
                                            <div className='flex text-center items-center'>
                                              <div className='pr-4 w-48 text-start'>
                                                <h3>Questionnaire garant n°{currentSubPage - 1}</h3>
                                              </div>

                                              <div className='pr-4 w-32 text-start'>
                                                <DocumentState etat={user.dossier.list_garants[currentSubPage - 2].questionnaire_etat}></DocumentState>
                                              </div>
                                            </div>

                                            <div className='flex text-center items-center'>
                                              <div className='pr-2 w-96'>
                                                <WidgetInputText state={messageQuestionnaire} setState={setMessageQuestionnaire} id={'message'} text={"Commentaire"} size="small" value={user.dossier.list_garants[currentSubPage - 2].questionnaire_message} />
                                              </div>

                                              <div className=''>
                                                <IconButton onClick={() => {
                                                  let payload = { 'message': messageQuestionnaire.value, 'rejet': true };
                                                  axios.post(CONFIG.API_URL + '/api/retour_garant/' + user._id + '/' + (currentSubPage - 2), payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                                    .then((response) => {
                                                      switch (response.status) {
                                                        case 200:
                                                          setUser(response.data);
                                                          break;

                                                        default:
                                                          break;
                                                      }
                                                    })
                                                    .catch((e) => {
                                                      let response = e.response;

                                                      if (response === undefined) {
                                                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                        return;
                                                      }

                                                      switch (response.status) {
                                                        default:
                                                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                          break;
                                                      }
                                                    });
                                                }}><CancelIcon className='text-red-500'></CancelIcon></IconButton>
                                              </div>

                                              <div className=''>
                                                <IconButton onClick={() => {
                                                  let payload = { 'message': messageQuestionnaire.value, 'rejet': false };
                                                  axios.post(CONFIG.API_URL + '/api/retour_garant/' + user._id + '/' + (currentSubPage - 2), payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                                    .then((response) => {
                                                      switch (response.status) {
                                                        case 200:
                                                          setUser(response.data);
                                                          break;

                                                        default:
                                                          break;
                                                      }
                                                    })
                                                    .catch((e) => {
                                                      let response = e.response;

                                                      if (response === undefined) {
                                                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                        return;
                                                      }

                                                      switch (response.status) {
                                                        default:
                                                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                          break;
                                                      }
                                                    });
                                                }}><CheckCircleIcon className='text-green-500'></CheckCircleIcon></IconButton>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      {currentPage === 1 && (current.roles.role_admin_read || current.roles.role_admin_write) &&
                        <div className='col-span-12 w-full mx-auto shrink-0 bg-gray-50 my-shadow'>
                          <div className='grid grid-cols-12 gap-x-4 mt-6'>
                            <div className='col-span-12 w-full text-center mb-2'>
                              <h1>Documents</h1>
                            </div>
                            <div className='col-span-12 w-full text-center mb-2 ml-6'>
                              <Tabs value={currentSubPage} onChange={handleChangeSubTab} variant="scrollable" scrollButtons="auto">
                                <Tab label="Locataire n°1" id="simple-tab-0" />
                                <Tab label="Locataire n°2" id="simple-tab-1" disabled={!user.dossier.avec_deuxieme_locataire} />
                                {user.dossier.list_garants.map((e, i) => <Tab key={i} label={"Garant n°" + (i + 1)} id={"simple-tab-" + (i + 2)} />)}
                                {user.dossier.avec_visale && <Tab label="Garantie visale" id="simple-tab-10" />}
                              </Tabs>
                            </div>

                            <div className='col-span-12 w-full mx-auto shrink-0 bg-white my-shadow'>
                              <div className='grid grid-cols-12 gap-x-4 mt-6'>
                                <div className='col-span-12 w-full'>
                                  {currentPage === 1 && currentSubPage === 0 &&
                                    <FicheMetaGroupDocuments
                                      user={user} setUser={setUser} metaGroupIcon={<FolderIcon fontSize='large'></FolderIcon>} metaGroupName={"Documents locataire n°1"} groupList={
                                        [
                                          {
                                            groupIcon: <PersonIcon fontSize='large'></PersonIcon>,
                                            groupName: "Personnel",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Pièce d'identité",
                                                description: "Pièce d'identité recto verso à jour : carte ID, passeport ou titre de séjour.",
                                                type_dossier: "dossier",
                                                document_name: "piece_identite",
                                                facultatif: user.dossier.documents.piece_identite.facultatif_cond && !(user.dossier.documents.piece_identite.obligatoire_cond || user.dossier.documents.piece_identite.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Mandat de recherche",
                                                description: <>Mandat de recherche (<a className='underline' href={CONFIG.API_URL + '/api/lettre_mission'}>téléchargeable ici</a>) à remplir et signer.</>,
                                                type_dossier: "dossier",
                                                document_name: "lettre_mission",
                                                facultatif: user.dossier.documents.lettre_mission.facultatif_cond && !(user.dossier.documents.lettre_mission.obligatoire_cond || user.dossier.documents.lettre_mission.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Accord employeur",
                                                description: <>Document (<a className='underline' href={CONFIG.API_URL + '/api/accord_employeur'}>téléchargeable ici</a>) à faire remplir, signer et tamponner par votre nouvelle entreprise.</>,
                                                type_dossier: "dossier",
                                                document_name: "accord_employeur",
                                                facultatif: user.dossier.documents.accord_employeur.facultatif_cond && !(user.dossier.documents.accord_employeur.obligatoire_cond || user.dossier.documents.accord_employeur.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Attestation sur l'honneur de séparation",
                                                description: "LOREM IPSUM DOLOR SIT AMET",
                                                type_dossier: "dossier",
                                                document_name: "attestation_separation",
                                                facultatif: user.dossier.documents.attestation_separation.facultatif_cond && !(user.dossier.documents.attestation_separation.obligatoire_cond || user.dossier.documents.attestation_separation.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <HomeIcon fontSize='large'></HomeIcon>,
                                            groupName: "Justificatifs de domicile",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "3 Dernières quittance de loyer",
                                                description: "Les avis d'échéance sont autorisés s'ils précisent un solde antérieur égal à 0€.",
                                                type_dossier: "dossier",
                                                document_name: "quittances_loyer",
                                                facultatif: user.dossier.documents.quittances_loyer.facultatif_cond && !(user.dossier.documents.quittances_loyer.obligatoire_cond || user.dossier.documents.quittances_loyer.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Taxe foncière recto-verso (N-1)",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: "dossier",
                                                document_name: "taxe_fonciere",
                                                facultatif: user.dossier.documents.taxe_fonciere.facultatif_cond && !(user.dossier.documents.quittances_loyer.obligatoire_cond || user.dossier.documents.quittances_loyer.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Facture de moins d'un mois",
                                                description: "Factures acceptées : eau, gaz ou internet de moins d'un mois. L'échéancier n'est pas pris en compte.",
                                                type_dossier: "dossier",
                                                document_name: "facture_domicile",
                                                facultatif: user.dossier.documents.facture_domicile.facultatif_cond && !(user.dossier.documents.facture_domicile.obligatoire_cond || user.dossier.documents.facture_domicile.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Attestation d'hébergement",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: "dossier",
                                                document_name: "attestation_hebergement",
                                                facultatif: user.dossier.documents.attestation_hebergement.facultatif_cond && !(user.dossier.documents.attestation_hebergement.obligatoire_cond || user.dossier.documents.attestation_hebergement.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Carte d'identitée de l'hébergeur",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: "dossier",
                                                document_name: "carte_identite_hebergeur",
                                                facultatif: user.dossier.documents.carte_identite_hebergeur.facultatif_cond && !(user.dossier.documents.carte_identite_hebergeur.obligatoire_cond || user.dossier.documents.carte_identite_hebergeur.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Facture de l'hébergeur",
                                                description: "Factures acceptées : eau, gaz ou internet de moins d'un mois. L'échéancier n'est pas pris en compte.",
                                                type_dossier: "dossier",
                                                document_name: "facture_domicile_hebergeur",
                                                facultatif: user.dossier.documents.facture_domicile_hebergeur.facultatif_cond && !(user.dossier.documents.facture_domicile_hebergeur.obligatoire_cond || user.dossier.documents.facture_domicile_hebergeur.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <WorkIcon fontSize='large'></WorkIcon>,
                                            groupName: "Justificatifs de travail",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Contrat de travail (ou attestation/promesse d'emploi de moins d'un mois)",
                                                description: "Signée et tamponnée par l'entreprise. Si le document a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                                                type_dossier: "dossier",
                                                document_name: "contrat_travail",
                                                facultatif: user.dossier.documents.contrat_travail.facultatif_cond && !(user.dossier.documents.contrat_travail.obligatoire_cond || user.dossier.documents.contrat_travail.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Certificat de signature électronique du contrat de travail",
                                                description: "Si le document a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                                                type_dossier: "dossier",
                                                document_name: "certificat_signature_elec_contrat",
                                                facultatif: user.dossier.documents.certificat_signature_elec_contrat.facultatif_cond && !(user.dossier.documents.certificat_signature_elec_contrat.obligatoire_cond || user.dossier.documents.certificat_signature_elec_contrat.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Avenant ou avis de mutation",
                                                description: "Signée et tamponnée par l'entreprise. Si le document a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                                                type_dossier: "dossier",
                                                document_name: "avis_mutation",
                                                facultatif: user.dossier.documents.avis_mutation.facultatif_cond && !(user.dossier.documents.avis_mutation.obligatoire_cond || user.dossier.documents.avis_mutation.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Certificat de signature de l'avenant ou de l'avis de mutation",
                                                description: "Si le document a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                                                type_dossier: "dossier",
                                                document_name: "certificat_signature_elec_mutation",
                                                facultatif: user.dossier.documents.certificat_signature_elec_mutation.facultatif_cond && !(user.dossier.documents.certificat_signature_elec_mutation.obligatoire_cond || user.dossier.documents.certificat_signature_elec_mutation.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Contrat d'alternance (ou attestation/promesse d'emploi de moins d'un mois)",
                                                description: "Signé et tamponné par l'entreprise. Les deux pages du contrat doivent figurer.",
                                                type_dossier: "dossier",
                                                document_name: "contrat_apprentissage",
                                                facultatif: user.dossier.documents.contrat_apprentissage.facultatif_cond && !(user.dossier.documents.contrat_apprentissage.obligatoire_cond || user.dossier.documents.contrat_apprentissage.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Carte étudiante ou attestation de formation",
                                                description: "Correspondant à l'année du contrat d'alternance + l'attestation ou carte étudiante actuelle si l'année étudiante en cours n'est pas terminée.",
                                                type_dossier: "dossier",
                                                document_name: "certificat_scolarite",
                                                facultatif: user.dossier.documents.certificat_scolarite.facultatif_cond && !(user.dossier.documents.certificat_scolarite.obligatoire_cond || user.dossier.documents.certificat_scolarite.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <SavingsIcon fontSize='large'></SavingsIcon>,
                                            groupName: "Impôts et revenus",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Deux derniers avis d'impositions (N-1 et N-2) avec toutes les pages ou l'ASDIR",
                                                description: "Pour les ressortissants étrangers l'ASDIR (anciennement avis de non-imposition) à demander à l'administration fiscale ou le justificatif fiscale du pays d'origine traduit en français et converti en euros. Si rattaché sur les deux derniers avis, merci de fournir les deux documents",
                                                type_dossier: "dossier",
                                                document_name: "avis_imposition",
                                                facultatif: user.dossier.documents.avis_imposition.facultatif_cond && !(user.dossier.documents.avis_imposition.obligatoire_cond || user.dossier.documents.avis_imposition.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Attestation de rattachement fiscal",
                                                description: "Si rattaché sur les deux derniers avis, merci d'indiquer les deux années d'imposition (et non les années de réception de l'avis)",
                                                type_dossier: "dossier",
                                                document_name: "attestation_ratachement",
                                                facultatif: user.dossier.documents.attestation_ratachement.facultatif_cond && !(user.dossier.documents.attestation_ratachement.obligatoire_cond || user.dossier.documents.attestation_ratachement.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Carte d'identité du/des parents",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: "dossier",
                                                document_name: "carte_identite_ratacheur",
                                                facultatif: user.dossier.documents.carte_identite_ratacheur.facultatif_cond && !(user.dossier.documents.carte_identite_ratacheur.obligatoire_cond || user.dossier.documents.carte_identite_ratacheur.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "3 derniers bulletins de salaire",
                                                description: "Si document en plusieurs pages, toutes les pages doivent figurer.",
                                                type_dossier: "dossier",
                                                document_name: "bultins_salaire",
                                                facultatif: user.dossier.documents.bultins_salaire.facultatif_cond && !(user.dossier.documents.bultins_salaire.obligatoire_cond || user.dossier.documents.bultins_salaire.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Livret de famille",
                                                description: "L'organisme nous demande ce document afin de prouver le rattachement fiscal. Cf liste des documents Mobili-Pass sur le site Action Logement.",
                                                type_dossier: "dossier",
                                                document_name: "livret_famille",
                                                facultatif: user.dossier.documents.livret_famille.facultatif_cond && !(user.dossier.documents.livret_famille.obligatoire_cond || user.dossier.documents.livret_famille.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <AddBoxIcon fontSize='large'></AddBoxIcon>,
                                            groupName: "Dépôt libre",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Dépôt libre",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: "dossier",
                                                document_name: "depot_libre",
                                                facultatif: true
                                              });

                                              return result;
                                            })(),
                                          },
                                        ]
                                      }
                                    />
                                  }
                                  {currentPage === 1 && currentSubPage === 1 &&
                                    <FicheMetaGroupDocuments
                                      user={user} setUser={setUser} metaGroupIcon={<FolderIcon fontSize='large'></FolderIcon>} metaGroupName={"Documents locataire n°1"} groupList={
                                        [
                                          {
                                            groupIcon: <PersonIcon fontSize='large'></PersonIcon>,
                                            groupName: "Personnel",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Pièce d'identité",
                                                description: "Pièce d'identité recto verso à jour : carte ID, passeport ou titre de séjour.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "piece_identite",
                                                facultatif: user.dossier.deuxieme_locataire.documents.piece_identite.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.piece_identite.obligatoire_cond || user.dossier.deuxieme_locataire.documents.piece_identite.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <HomeIcon fontSize='large'></HomeIcon>,
                                            groupName: "Justificatifs de domicile",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "3 Dernières quittance de loyer",
                                                description: "Les avis d'échéance sont autorisés s'ils précisent un solde antérieur égal à 0€.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "quittances_loyer",
                                                facultatif: user.dossier.deuxieme_locataire.documents.quittances_loyer.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.quittances_loyer.obligatoire_cond || user.dossier.deuxieme_locataire.documents.quittances_loyer.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Taxe foncière recto-verso (N-1)",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "taxe_fonciere",
                                                facultatif: user.dossier.deuxieme_locataire.documents.taxe_fonciere.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.taxe_fonciere.obligatoire_cond || user.dossier.deuxieme_locataire.documents.taxe_fonciere.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Facture de moins d'un mois",
                                                description: "Factures acceptées : eau, gaz ou internet de moins d'un mois. L'échéancier n'est pas pris en compte.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "facture_domicile",
                                                facultatif: user.dossier.deuxieme_locataire.documents.facture_domicile.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.facture_domicile.obligatoire_cond || user.dossier.deuxieme_locataire.documents.facture_domicile.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Attestation d'hébergement",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "attestation_hebergement",
                                                facultatif: user.dossier.deuxieme_locataire.documents.attestation_hebergement.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.attestation_hebergement.obligatoire_cond || user.dossier.deuxieme_locataire.documents.attestation_hebergement.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Carte d'identitée de l'hébergeur",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "carte_identite_hebergeur",
                                                facultatif: user.dossier.deuxieme_locataire.documents.carte_identite_hebergeur.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.carte_identite_hebergeur.obligatoire_cond || user.dossier.deuxieme_locataire.documents.carte_identite_hebergeur.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Facture de l'hébergeur",
                                                description: "Factures acceptées : eau, gaz ou internet de moins d'un mois. L'échéancier n'est pas pris en compte.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "facture_domicile_hebergeur",
                                                facultatif: user.dossier.deuxieme_locataire.documents.facture_domicile_hebergeur.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.facture_domicile_hebergeur.obligatoire_cond || user.dossier.deuxieme_locataire.documents.facture_domicile_hebergeur.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <WorkIcon fontSize='large'></WorkIcon>,
                                            groupName: "Justificatifs de travail",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Contrat de travail (ou attestation/promesse d'emploi de moins d'un mois)",
                                                description: "Signée et tamponnée par l'entreprise. Si le document a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "contrat_travail",
                                                facultatif: user.dossier.deuxieme_locataire.documents.contrat_travail.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.contrat_travail.obligatoire_cond || user.dossier.deuxieme_locataire.documents.contrat_travail.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Certificat de signature électronique du contrat de travail",
                                                description: "Si le document a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "certificat_signature_elec_contrat",
                                                facultatif: user.dossier.deuxieme_locataire.documents.certificat_signature_elec_contrat.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.certificat_signature_elec_contrat.obligatoire_cond || user.dossier.deuxieme_locataire.documents.certificat_signature_elec_contrat.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Attestation employeur ou arrêté de titularisation",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: 'deuxieme_locataire',
                                                document_name: "arrete_titularisation",
                                                facultatif: user.dossier.deuxieme_locataire.documents.arrete_titularisation.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.arrete_titularisation.obligatoire_cond || user.dossier.deuxieme_locataire.documents.arrete_titularisation.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "2 Derniers bilans comptables",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: 'deuxieme_locataire',
                                                document_name: "bilans_comptable",
                                                facultatif: user.dossier.deuxieme_locataire.documents.bilans_comptable.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.bilans_comptable.obligatoire_cond || user.dossier.deuxieme_locataire.documents.bilans_comptable.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Extrait K-Bis",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: 'deuxieme_locataire',
                                                document_name: "k_bis",
                                                facultatif: user.dossier.deuxieme_locataire.documents.k_bis.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.k_bis.obligatoire_cond || user.dossier.deuxieme_locataire.documents.k_bis.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Déclarations URSSAF",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: 'deuxieme_locataire',
                                                document_name: "declaration_urssaf",
                                                facultatif: user.dossier.deuxieme_locataire.documents.declaration_urssaf.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.declaration_urssaf.obligatoire_cond || user.dossier.deuxieme_locataire.documents.declaration_urssaf.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Carte professionnelle",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: 'deuxieme_locataire',
                                                document_name: "carte_professionnelle",
                                                facultatif: user.dossier.deuxieme_locataire.documents.carte_professionnelle.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.carte_professionnelle.obligatoire_cond || user.dossier.deuxieme_locataire.documents.carte_professionnelle.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Attestation de salaire",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: 'deuxieme_locataire',
                                                document_name: "attestation_salaire",
                                                facultatif: user.dossier.deuxieme_locataire.documents.attestation_salaire.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.attestation_salaire.obligatoire_cond || user.dossier.deuxieme_locataire.documents.attestation_salaire.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "3 Derniers justificatifs de paiement de(s) caisse(s) de retraite",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: 'deuxieme_locataire',
                                                document_name: "justificatifs_paiements_retraite",
                                                facultatif: user.dossier.deuxieme_locataire.documents.justificatifs_paiements_retraite.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.justificatifs_paiements_retraite.obligatoire_cond || user.dossier.deuxieme_locataire.documents.justificatifs_paiements_retraite.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Document d'ouverture de droit",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "ouverture_droit",
                                                facultatif: user.dossier.deuxieme_locataire.documents.ouverture_droit.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.ouverture_droit.obligatoire_cond || user.dossier.deuxieme_locataire.documents.ouverture_droit.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "3 derniers relevés de versement Pôle Emploi",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "releves_paiement",
                                                facultatif: user.dossier.deuxieme_locataire.documents.releves_paiement.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.releves_paiement.obligatoire_cond || user.dossier.deuxieme_locataire.documents.releves_paiement.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Carte étudiante ou attestation de formation",
                                                description: "Attestation ou carte étudiante actuelle si l'année étudiante en cours n'est pas terminée.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "certificat_scolarite",
                                                facultatif: user.dossier.deuxieme_locataire.documents.certificat_scolarite.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.certificat_scolarite.obligatoire_cond || user.dossier.deuxieme_locataire.documents.certificat_scolarite.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <SavingsIcon fontSize='large'></SavingsIcon>,
                                            groupName: "Impôts et revenus",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Deux derniers avis d'impositions (N-1 et N-2) avec toutes les pages ou l'ASDIR",
                                                description: "Pour les ressortissants étrangers l'ASDIR (anciennement avis de non-imposition) à demander à l'administration fiscale ou le justificatif fiscale du pays d'origine traduit en français et converti en euros. Si rattaché sur les deux derniers avis, merci de fournir les deux documents",
                                                type_dossier: 'deuxieme_locataire',
                                                document_name: "avis_imposition",
                                                facultatif: user.dossier.deuxieme_locataire.documents.avis_imposition.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.avis_imposition.obligatoire_cond || user.dossier.deuxieme_locataire.documents.avis_imposition.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Attestation de rattachement fiscal",
                                                description: "Si rattaché sur les deux derniers avis, merci d'indiquer les deux années d'imposition (et non les années de réception de l'avis)",
                                                type_dossier: 'deuxieme_locataire',
                                                document_name: "attestation_ratachement",
                                                facultatif: user.dossier.deuxieme_locataire.documents.attestation_ratachement.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.attestation_ratachement.obligatoire_cond || user.dossier.deuxieme_locataire.documents.attestation_ratachement.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Carte d'identité du/des parents",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: 'deuxieme_locataire',
                                                document_name: "carte_identite_ratacheur",
                                                facultatif: user.dossier.deuxieme_locataire.documents.carte_identite_ratacheur.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.carte_identite_ratacheur.obligatoire_cond || user.dossier.deuxieme_locataire.documents.carte_identite_ratacheur.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "3 derniers bulletins de salaire",
                                                description: "Si document en plusieurs pages, toutes les pages doivent figurer.",
                                                type_dossier: 'deuxieme_locataire',
                                                document_name: "bultins_salaire",
                                                facultatif: user.dossier.deuxieme_locataire.documents.bultins_salaire.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.bultins_salaire.obligatoire_cond || user.dossier.deuxieme_locataire.documents.bultins_salaire.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Livret de famille",
                                                description: "L'organisme nous demande ce document afin de prouver le rattachement fiscal. Cf liste des documents Mobili-Pass sur le site Action Logement.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "livret_famille",
                                                facultatif: user.dossier.deuxieme_locataire.documents.livret_famille.facultatif_cond && !(user.dossier.deuxieme_locataire.documents.livret_famille.obligatoire_cond || user.dossier.deuxieme_locataire.documents.livret_famille.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <AddBoxIcon fontSize='large'></AddBoxIcon>,
                                            groupName: "Dépôt libre",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Dépôt libre",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: "deuxieme_locataire",
                                                document_name: "depot_libre",
                                                facultatif: true
                                              });

                                              return result;
                                            })(),
                                          },
                                        ]
                                      }
                                    />
                                  }
                                  {currentPage === 1 && currentSubPage > 1 && currentSubPage - 2 < user.dossier.list_garants.length &&
                                    <FicheMetaGroupDocuments
                                      key={currentSubPage} user={user} setUser={setUser} metaGroupIcon={<FolderIcon fontSize='large'></FolderIcon>} metaGroupName={"Documents locataire n°1"} groupList={
                                        [
                                          {
                                            groupIcon: <PersonIcon fontSize='large'></PersonIcon>,
                                            groupName: "Personnel",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Pièce d'identité",
                                                description: "Pièce d'identité recto verso à jour : carte ID, passeport ou titre de séjour.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "piece_identite",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.piece_identite.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.piece_identite.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.piece_identite.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <HomeIcon fontSize='large'></HomeIcon>,
                                            groupName: "Justificatifs de domicile",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "3 Dernières quittance de loyer",
                                                description: "Les avis d'échéance sont autorisés s'ils précisent un solde antérieur égal à 0€.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "quittances_loyer",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.quittances_loyer.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.quittances_loyer.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.quittances_loyer.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Taxe foncière recto-verso (N-1)",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "taxe_fonciere",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.taxe_fonciere.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.taxe_fonciere.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.taxe_fonciere.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Facture de moins d'un mois",
                                                description: "Factures acceptées : eau, gaz ou internet de moins d'un mois. L'échéancier n'est pas pris en compte.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "facture_domicile",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.facture_domicile.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.facture_domicile.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.facture_domicile.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Attestation d'hébergement",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "attestation_hebergement",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.attestation_hebergement.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.attestation_hebergement.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.attestation_hebergement.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Carte d'identitée de l'hébergeur",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "carte_identite_hebergeur",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.carte_identite_hebergeur.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.carte_identite_hebergeur.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.carte_identite_hebergeur.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Facture de l'hébergeur",
                                                description: "Factures acceptées : eau, gaz ou internet de moins d'un mois. L'échéancier n'est pas pris en compte.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "facture_domicile_hebergeur",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.facture_domicile_hebergeur.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.facture_domicile_hebergeur.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.facture_domicile_hebergeur.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <WorkIcon fontSize='large'></WorkIcon>,
                                            groupName: "Justificatifs de travail",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Contrat de travail (ou attestation/promesse d'emploi de moins d'un mois)",
                                                description: "Signée et tamponnée par l'entreprise. Si le document a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "contrat_travail",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.contrat_travail.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.contrat_travail.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.contrat_travail.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Certificat de signature électronique du contrat de travail",
                                                description: "Si le document a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "certificat_signature_elec_contrat",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.certificat_signature_elec_contrat.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.certificat_signature_elec_contrat.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.certificat_signature_elec_contrat.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Attestation employeur ou arrêté de titularisation",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "arrete_titularisation",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.arrete_titularisation.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.arrete_titularisation.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.arrete_titularisation.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "2 Derniers bilans comptables",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "bilans_comptable",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.bilans_comptable.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.bilans_comptable.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.bilans_comptable.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Extrait de K-Bis de moins de 3 mois",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "k_bis",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.k_bis.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.k_bis.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.k_bis.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Déclarations URSSAF",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "declaration_urssaf",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.declaration_urssaf.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.declaration_urssaf.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.declaration_urssaf.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Carte professionnelle",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "carte_professionnelle",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.carte_professionnelle.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.carte_professionnelle.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.carte_professionnelle.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Attestation de salaire",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "attestation_salaire",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.attestation_salaire.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.attestation_salaire.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.attestation_salaire.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "3 Derniers justificatifs de paiement de(s) caisse(s) de retraite",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "justificatifs_paiements_retraite",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.justificatifs_paiements_retraite.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.justificatifs_paiements_retraite.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.justificatifs_paiements_retraite.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Ouverture de droit",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "ouverture_droit",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.ouverture_droit.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.ouverture_droit.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.ouverture_droit.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "3 derniers relevés de versement Pôle Emploi",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "releves_paiement",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.releves_paiement.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.releves_paiement.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.releves_paiement.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <SavingsIcon fontSize='large'></SavingsIcon>,
                                            groupName: "Impôts et revenus",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Deux derniers avis d'impositions (N-1 et N-2) avec toutes les pages ou l'ASDIR",
                                                description: "Pour les ressortissants étrangers l'ASDIR (anciennement avis de non-imposition) à demander à l'administration fiscale ou le justificatif fiscale du pays d'origine traduit en français et converti en euros. Si rattaché sur les deux derniers avis, merci de fournir les deux documents",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "avis_imposition",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.avis_imposition.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.avis_imposition.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.avis_imposition.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Attestation de rattachement fiscal",
                                                description: "Si rattaché sur les deux derniers avis, merci d'indiquer les deux années d'imposition (et non les années de réception de l'avis)",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "attestation_ratachement",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.attestation_ratachement.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.attestation_ratachement.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.attestation_ratachement.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Carte d'identité du/des parents",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "carte_identite_ratacheur",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.carte_identite_ratacheur.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.carte_identite_ratacheur.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.carte_identite_ratacheur.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "3 derniers bulletins de salaire",
                                                description: "Si document en plusieurs pages, toutes les pages doivent figurer.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "bultins_salaire",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.bultins_salaire.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.bultins_salaire.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.bultins_salaire.obligatoire_admin)
                                              });

                                              result.push({
                                                titre: "Livret de famille",
                                                description: "L'organisme nous demande ce document afin de prouver le rattachement fiscal. Cf liste des documents Mobili-Pass sur le site Action Logement.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "livret_famille",
                                                facultatif: user.dossier.list_garants[currentSubPage - 2].documents.livret_famille.facultatif_cond && !(user.dossier.list_garants[currentSubPage - 2].documents.livret_famille.obligatoire_cond || user.dossier.list_garants[currentSubPage - 2].documents.livret_famille.obligatoire_admin)
                                              });

                                              return result;
                                            })(),
                                          },
                                          {
                                            groupIcon: <AddBoxIcon fontSize='large'></AddBoxIcon>,
                                            groupName: "Dépôt libre",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Dépôt libre",
                                                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                                type_dossier: currentSubPage - 2,
                                                document_name: "depot_libre",
                                                facultatif: true
                                              });

                                              return result;
                                            })(),
                                          },
                                        ]
                                      }
                                    />
                                  }
                                  {currentPage === 1 && currentSubPage - 2 === user.dossier.list_garants.length && user.dossier.avec_visale &&
                                    <FicheMetaGroupDocuments
                                      key={currentSubPage} user={user} setUser={setUser} metaGroupIcon={<FolderIcon fontSize='large'></FolderIcon>} metaGroupName={"Garantie visale"} groupList={
                                        [
                                          {
                                            groupIcon: <PersonIcon fontSize='large'></PersonIcon>,
                                            groupName: "Garantie visale",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Garantie visale",
                                                description: "LOREM IPSUM DOLOR SIT AMET",
                                                type_dossier: "dossier",
                                                document_name: "garantie_visale",
                                                facultatif: false
                                              });

                                              return result;
                                            })(),
                                          },
                                        ]
                                      }
                                    />
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      {currentPage === 2 && (current.roles.role_admin_read || current.roles.role_admin_write) &&
                        <div className='col-span-12 w-full mx-auto shrink-0 bg-gray-50 my-shadow'>
                          <div className='grid grid-cols-12 gap-x-4 mt-6'>
                            <div className='col-span-12 w-full text-center mb-6'>
                              <h1>Vérification</h1>
                            </div>
                            <div className='col-span-12 max-w-4xl mx-auto text-center mb-6 px-6'>
                              <FicheEtatDossier user={user} setUser={setUser}></FicheEtatDossier>
                            </div>

                            {user.dossier.avec_deuxieme_locataire &&
                              <div className='col-span-12 max-w-4xl mx-auto text-center mb-6 px-6'>
                                <FicheEtatDossierLoc user={user} setUser={setUser}></FicheEtatDossierLoc>
                              </div>
                            }

                            {user.dossier.list_garants.map((e, i) =>
                              <>
                                <div key={i} className='col-span-12 max-w-4xl mx-auto text-center mb-6 px-6'>
                                  <FicheEtatDossierGarant user={user} setUser={setUser} i={i}></FicheEtatDossierGarant>
                                </div>
                              </>
                            )}

                          </div>
                        </div>
                      }

                      {currentPage === 3 && (current.roles.role_admin_read || current.roles.role_admin_write) &&
                        <div className='col-span-12 w-full mx-auto shrink-0 bg-gray-50 my-shadow'>
                          <div className='grid grid-cols-12 gap-x-4 mt-6'>
                            <div className='col-span-12 w-full text-center mb-6'>
                              <h1>Attribution/Proposition</h1>
                            </div>
                            <div className='col-span-12 w-full text-center px-6'>
                              {current.roles.role_admin_write &&
                                <>
                                  <div className='max-w-4xl mx-auto shrink-0'>
                                    <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 py-6 px-6 bg-white my-shadow'>
                                      <div className='col-span-12 mb-4'>
                                        <h2>Attribution forcée</h2>
                                      </div>

                                      <div className='col-span-12 mb-4 text-left'>
                                        <WidgetSelect state={commercialAttribution} setState={setCommercialAttribution} id={'temp'} text={"Attribuer à "} value={user.dossier.id_commercial}
                                          options={commerciaux} readOnly={user.dossier.id_commercial !== null}
                                        />
                                      </div>

                                      <div className='col-start-7 col-span-3 mb-4'>
                                        <Button className='w-full' variant='outlined'
                                          onClick={() => {
                                            axios.post(CONFIG.API_URL + '/api/attribution_client_cancel/' + user._id, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                              .then((response) => {
                                                switch (response.status) {
                                                  case 200:
                                                    setUser(response.data);
                                                    setCommercialAttribution(s => ({ ...s, value: "" }));
                                                    openSnackDesAttribut();
                                                    break;

                                                  default:
                                                    break;
                                                }
                                              })
                                              .catch((e) => {
                                                let response = e.response;

                                                if (response === undefined) {
                                                  alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                  return;
                                                }

                                                switch (response.status) {
                                                  default:
                                                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                    break;
                                                }
                                              });
                                          }}
                                        >Annuler</Button>
                                      </div>

                                      <div className='col-start-10 col-span-3 mb-4'>
                                        <Button className='w-full' variant='contained' disabled={user.dossier.id_commercial !== null || commercialAttribution?.value === ''}
                                          onClick={() => {
                                            axios.post(CONFIG.API_URL + '/api/attribution_client_commercial/' + user._id + '/' + commercialAttribution.value, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                              .then((response) => {
                                                switch (response.status) {
                                                  case 200:
                                                    setUser(response.data);
                                                    openSnackAttribut();
                                                    break;

                                                  default:
                                                    break;
                                                }
                                              })
                                              .catch((e) => {
                                                let response = e.response;

                                                if (response === undefined) {
                                                  alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                  return;
                                                }

                                                switch (response.status) {
                                                  default:
                                                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                    break;
                                                }
                                              });
                                          }}
                                        >Attribuer</Button>
                                      </div>

                                      <div className='col-span-12 mb-4'>
                                        <h2>Proposition</h2>
                                      </div>

                                      <div className='col-span-12 mb-4 text-left'>
                                        <WidgetSelect state={commerciauxProposition} setState={setCommerciauxProposition} id={'temp'} text={"Proposer à "} multiple={true} value={user.dossier.dossiers_propose.map(x => x.id_commercial)}
                                          options={commerciaux} readOnly={user.dossier.id_commercial !== null}
                                        />
                                      </div>

                                      <div className='col-span-9 text-left'>
                                        <WidgetCheckbox state={secteurProposition} setState={setSecteurProposition} id={'test'} text={"Proposer au secteur (" + nbCommerciauxSecteur + ")"} disabled={user.dossier.id_commercial !== null} />
                                      </div>

                                      <div className='col-span-3 float-right'>
                                        <Button className='w-full' variant='contained' disabled={user.dossier.id_commercial !== null}
                                          onClick={() => {
                                            axios.post(CONFIG.API_URL + '/api/proposition_client_commercial/' + user._id, { list_id_commercial: commerciauxProposition.value, secteur: secteurProposition.value }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                              .then((response) => {
                                                switch (response.status) {
                                                  case 200:
                                                    setUser(response.data);
                                                    setCommerciauxProposition((s) => ({ ...s, value: response.data.dossier.dossiers_propose.map(x => x.id_commercial), error: false }));
                                                    openSnackPropose();
                                                    break;

                                                  default:
                                                    break;
                                                }
                                              })
                                              .catch((e) => {
                                                let response = e.response;

                                                if (response === undefined) {
                                                  alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                  return;
                                                }

                                                switch (response.status) {
                                                  default:
                                                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                    break;
                                                }
                                              });
                                          }}
                                        >Proposer</Button>
                                      </div>

                                      {/* <div className="col-span-12 grid grid-cols-12 gap-4">
                                        <div className="col-span-6 grid grid-cols-12 h-min">
                                          {Object.keys(commerciaux).map(key => {
                                            return (<FicheWidgetCommercial key={key} id_commercial={key} name_commercial={commerciaux[key]} user={user} setUser={setUser}></FicheWidgetCommercial>)
                                          })}
                                        </div>
                                      </div> */}
                                    </div>
                                  </div>
                                </>
                              }
                            </div>
                          </div>
                        </div>
                      }

                      {currentPage === 4 &&
                        <div className='col-span-12 w-full mx-auto shrink-0 bg-gray-50 my-shadow'>
                          <div className='grid grid-cols-12 gap-x-4'>
                            <div className='col-span-12 w-full text-center px-6'>
                              {user.roles.role_client &&
                                <>
                                  <div className='max-w-4xl mx-auto shrink-0'>
                                    <div className='grid grid-cols-12 gap-x-4 m-6'>
                                      <div className='col-span-12 w-full text-center'>
                                        <h1>Valider la recherche d'appartement</h1>
                                      </div>
                                    </div>

                                    <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 py-6 px-6 bg-white my-shadow'>
                                      <div className='col-span-12 mb-4'>
                                        <h2>Adresse finale</h2>
                                      </div>

                                      <div className='col-span-12 w-full mb-4'>
                                        <WidgetInputText state={adresse1} setState={setAdresse1} id={'dossier___adresse_depart___adresse'} text={"Adresse"} value={user.dossier.adresse_arrive.adresse} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4'>
                                        <WidgetInputText state={codePostal1} setState={setCodePostal1} id={'dossier___adresse_depart___code_postal'} text={"Code postal"} value={user.dossier.adresse_arrive.code_postal} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4'>
                                        <WidgetInputVille state={ville1} setState={setVille1} code_postal={codePostal1?.value} id={'dossier___adresse_depart___ville'} text={"Ville"} value={user.dossier.adresse_arrive.ville} />
                                      </div>

                                      {codePostal1 !== null && codePostal1.value === '99999' &&
                                        <div className='col-span-6 w-full mb-4'>
                                          <WidgetInputText state={pays1} setState={setPays1} id={'dossier___adresse_depart___pays'} text={"Pays"} value={user.dossier.adresse_arrive.pays} />
                                        </div>
                                      }


                                      <div className='col-span-12 mb-4'>
                                        <h2>Adresse autre visite</h2>
                                      </div>

                                      <div className='col-span-12 w-full mb-4'>
                                        <WidgetInputText state={adresse2} setState={setAdresse2} id={'dossier___adresse_depart___adresse'} text={"Adresse"} value={user.dossier.adresses_visite[0].adresse} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4'>
                                        <WidgetInputText state={codePostal2} setState={setCodePostal2} id={'dossier___adresse_depart___code_postal'} text={"Code postal"} value={user.dossier.adresses_visite[0].code_postal} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4'>
                                        <WidgetInputVille state={ville2} setState={setVille2} code_postal={codePostal2?.value} id={'dossier___adresse_depart___ville'} text={"Ville"} value={user.dossier.adresses_visite[0].ville} />
                                      </div>

                                      {codePostal2 !== null && codePostal2.value === '99999' &&
                                        <div className='col-span-6 w-full mb-4'>
                                          <WidgetInputText state={pays2} setState={setPays2} id={'dossier___adresse_depart___pays'} text={"Pays"} value={user.dossier.adresses_visite[0].pays} />
                                        </div>
                                      }


                                      <div className='col-span-12 mb-4'>
                                        <h2>Adresse autre visite bis</h2>
                                      </div>

                                      <div className='col-span-12 w-full mb-4'>
                                        <WidgetInputText state={adresse3} setState={setAdresse3} id={'dossier___adresse_depart___adresse'} text={"Adresse"} value={user.dossier.adresses_visite[1].adresse} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4'>
                                        <WidgetInputText state={codePostal3} setState={setCodePostal3} id={'dossier___adresse_depart___code_postal'} text={"Code postal"} value={user.dossier.adresses_visite[1].code_postal} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4'>
                                        <WidgetInputVille state={ville3} setState={setVille3} code_postal={codePostal3?.value} id={'dossier___adresse_depart___ville'} text={"Ville"} value={user.dossier.adresses_visite[1].ville} />
                                      </div>

                                      {codePostal3 !== null && codePostal3.value === '99999' &&
                                        <div className='col-span-6 w-full mb-4'>
                                          <WidgetInputText state={pays3} setState={setPays3} id={'dossier___adresse_depart___pays'} text={"Pays"} value={user.dossier.adresses_visite[1].pays} />
                                        </div>
                                      }


                                      <div className='col-span-12 mb-4'>
                                        <h2>Dates</h2>
                                      </div>

                                      <div className='col-span-6 w-full mb-4'>
                                        <WidgetDatePicker state={date1} setState={setDate1} id={'date1'} text={"Date de visites"} value={user.dossier.date_visite} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4'>
                                        <WidgetDatePicker state={date2} setState={setDate2} id={'date2'} text={"Date état des lieux"} value={user.dossier.date_installation} />
                                      </div>


                                      <div className='col-span-12 mb-4'>
                                        <h2>Facture</h2>
                                      </div>


                                      <div className="col-span-12 grid grid-cols-12 gap-4">
                                        <div className="col-span-6 grid grid-cols-12 h-min">
                                          {Object.keys(user.dossier.documents.facture_commercial.fichiers).map(key => {
                                            const file = user.dossier.documents.facture_commercial.fichiers[key];
                                            return (<WidgetFile key={key} id_client={user._id} type_dossier={"dossier"} document_name={"facture_commercial"} index={key} path={file.path} name={file.nom} setUser={setUser}></WidgetFile>)
                                          })}
                                        </div>
                                        <div className="col-span-6 mb-2 mr-2">
                                          <WidgetDropZone type_dossier="dossier" document_name="facture_commercial" user={user} setUser={setUser}></WidgetDropZone>
                                        </div>
                                      </div>

                                      <div className='col-start-11 col-span-2 w-full mb-4 float-right'>
                                        <Button className='w-full' variant='contained'
                                          onClick={() => {
                                            let payload = {
                                              adresse_fin_adresse: adresse1.value,
                                              adresse_fin_code_postal: codePostal1.value,
                                              adresse_fin_ville: ville1.value,
                                              adresse_fin_pays: pays1?.value,

                                              adresse_visite_1_adresse: adresse2.value,
                                              adresse_visite_1_code_postal: codePostal2.value,
                                              adresse_visite_1_ville: ville2.value,
                                              adresse_visite_1_pays: pays2?.value,

                                              adresse_visite_2_adresse: adresse3.value,
                                              adresse_visite_2_code_postal: codePostal3.value,
                                              adresse_visite_2_ville: ville3.value,
                                              adresse_visite_2_pays: pays3?.value,

                                              date1: (date1?.value === null) ? null : date1?.value.toISOString(),
                                              date2: (date2?.value === null) ? null : date2?.value.toISOString(),
                                            }

                                            axios.post(CONFIG.API_URL + '/api/validate_client/' + user._id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                              .then((response) => {
                                                switch (response.status) {
                                                  case 200:
                                                    setUser(response.data);
                                                    openSnackValide();
                                                    break;

                                                  default:
                                                    break;
                                                }
                                              })
                                              .catch((e) => {
                                                let response = e.response;

                                                if (response === undefined) {
                                                  alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                  return;
                                                }

                                                switch (response.status) {
                                                  default:
                                                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                    break;
                                                }
                                              });
                                          }}
                                        >Valider</Button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              }
                            </div>
                          </div>
                        </div>
                      }

                      {currentPage === 5 &&
                        <div className='col-span-12 w-full mx-auto shrink-0 bg-gray-50 my-shadow'>
                          <div className='grid grid-cols-12 gap-x-4 mt-6'>
                            <div className='col-span-12 w-full text-center mb-2'>
                              <h1>Envoie organisme</h1>
                            </div>
                            <div className='col-span-12 w-full text-center mb-2 ml-6'>
                              <Tabs value={currentSubPage} onChange={handleChangeSubTab} variant="scrollable" scrollButtons="auto">
                                <Tab label="Envoie organisme" id="simple-tab-0" />
                              </Tabs>
                            </div>

                            <div className='col-span-12 w-full mx-auto shrink-0 bg-white my-shadow'>
                              <div className='grid grid-cols-12 gap-x-4 mt-6'>
                                <div className='col-span-12 w-full'>
                                  <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 bg-white my-shadow'>
                                    <div className='col-span-12 w-full mb-4'>
                                      <h2>Facture</h2>
                                    </div>
                                    <div className='col-span-3 w-full'>
                                      <WidgetSelect state={typeFacture} setState={setTypeFacture} id={'type_facture'} text={"Type de facture"} value={{ 1000: 'facture_1000', 1500: 'facture_1500', 1900: 'facture_1900', 2200: 'facture_2200', 3200: 'facture_3200' }[user.dossier.previ_montant]}
                                        options={{
                                          'facture_1000': "Facture à 1000€",
                                          'facture_1500': "Facture à 1500€",
                                          'facture_1900': "Facture à 1900€",
                                          'facture_2200': "Facture à 2200€",
                                          'facture_3200': "Facture à 3200€"
                                        }}
                                      />
                                    </div>
                                    <div className='col-span-2 w-full text-left content-center grid'>
                                      <Button variant='contained' onClick={() => {
                                        axios.post(CONFIG.API_URL + '/api/set_note_prixfacture/' + user._id, { prix: typeFacture.value }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token'), 'Cache-Control': 'no-cache' } })
                                          .then((response) => {
                                            switch (response.status) {
                                              case 200:
                                                setUser(response.data);
                                                openSnackFacture();
                                                break;

                                              default:
                                                break;
                                            }
                                          })
                                          .catch((e) => {
                                            let response = e.response;

                                            if (response === undefined) {
                                              alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                              return;
                                            }

                                            switch (response.status) {
                                              default:
                                                alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                break;
                                            }
                                          });
                                      }}>
                                        Mettre à jour
                                      </Button>
                                    </div>
                                    <div className='col-span-2 w-full text-left content-center grid'>
                                      <Button variant='contained' onClick={() => { window.open(CONFIG.API_URL + '/api/facture/' + user._id) }}>
                                        Télécharger la facture
                                      </Button>
                                    </div>


                                    {(current.roles.role_admin_read || current.roles.role_admin_write) &&
                                      <>
                                        <div className='col-start-1 col-span-6 content-center grid mt-4'>
                                          <h2>Cerfa</h2>

                                          <ul className='list-disc list-inside mb-2'>
                                            <li className={(user.dossier.id_signature !== "" && user.dossier.id_signature !== "") ? 'text-green-600' : 'text-gray-300'}>Demande de signature envoyée au locataire n°1</li>
                                            <li className={(user.dossier.signer_ou_pas) ? 'text-green-600' : 'text-gray-300'}>Document signé par le locataire n°1</li>
                                            {user.dossier.avec_deuxieme_locataire &&
                                              <>
                                                <li className={(user.dossier.deuxieme_locataire.id_signature_deux !== "" && user.dossier.deuxieme_locataire.id_documents_signature_deux !== "") ? 'text-green-600' : 'text-gray-300'}>Demande de signature envoyée au locataire n°2</li>
                                                <li className={(user.dossier.deuxieme_locataire.signer_ou_pas_deux) ? 'text-green-600' : 'text-gray-300'}>Document signé par le locataire n°2</li>
                                              </>
                                            }
                                          </ul>

                                          <div className='inline-block'>
                                            <div className='mr-4 inline-block'>
                                              <Button variant='contained' onClick={() => {
                                                axios.get(CONFIG.API_URL + '/api/cerfa/' + user._id, { responseType: 'blob', headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token'), 'Cache-Control': 'no-cache' } })
                                                  .then((response) => {
                                                    switch (response.status) {
                                                      case 200:
                                                        // create file link in browser's memory
                                                        const href = URL.createObjectURL(response.data);

                                                        // create "a" HTML element with href to file & click
                                                        const link = document.createElement('a');
                                                        link.href = href;
                                                        link.setAttribute('download', user.nom + ' ' + user.prenom); //or any other extension
                                                        document.body.appendChild(link);
                                                        link.click();

                                                        // clean up "a" element & remove ObjectURL
                                                        document.body.removeChild(link);
                                                        URL.revokeObjectURL(href);
                                                        break;

                                                      default:
                                                        break;
                                                    }
                                                  })
                                                  .catch((e) => {
                                                    let response = e.response;

                                                    if (response === undefined) {
                                                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                      return;
                                                    }

                                                    switch (response.status) {
                                                      default:
                                                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                        break;
                                                    }
                                                  });
                                              }}>
                                                Vérifier le cerfa complété
                                              </Button>
                                            </div>

                                            <div className='mr-4 inline-block'>
                                              <Button variant='contained' onClick={() => {
                                                axios.post(CONFIG.API_URL + '/api/electronic_signature/' + user._id, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token'), 'Cache-Control': 'no-cache' } })
                                                  .then((response) => {
                                                    switch (response.status) {
                                                      case 200:
                                                        openSnackMailcrea();
                                                        setUser(response.data);
                                                        break;

                                                      default:
                                                        break;
                                                    }
                                                  })
                                                  .catch((e) => {
                                                    let response = e.response;

                                                    if (response === undefined) {
                                                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                      return;
                                                    }

                                                    switch (response.status) {
                                                      default:
                                                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                        break;
                                                    }
                                                  });
                                              }}>
                                                {(user.dossier.id_signature !== "" && user.dossier.id_documents_signature !== "") ? "Réenvoyer le mail de signature" : "Envoyer le mail de signature"}
                                              </Button>
                                            </div>
                                          </div>
                                        </div>

                                        <div className='col-span-6 content-start grid mt-4'>
                                          <h2>Dossier organisme</h2>

                                          <ul className='list-disc list-inside mb-2'>
                                            <li className={(user.dossier.etat === "envoye") ? 'text-green-600' : 'text-gray-300'}>Dossier envoyé à l'organisme</li>
                                          </ul>

                                          <div className='inline-block'>
                                            <div className='mr-4 inline-block'>
                                              <Button variant='contained' disabled={!(() => {
                                                var result = true;

                                                result = result && getDocument(user, "dossier", "cerfa").etat === 'valide';
                                                result = result && getDocument(user, "dossier", "certificat_signature_elec_cerfa").etat === 'valide';
                                                result = result && getDocument(user, "dossier", "piece_identite").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire)
                                                  result = result && getDocument(user, "deuxieme_locataire", "piece_identite").etat === 'valide';

                                                if ((current.roles.role_admin_read || current.roles.role_admin_write))
                                                  result = result && getDocument(user, "dossier", "accord_employeur").etat === 'valide';

                                                if (user.dossier.nombre_enfant > 0)
                                                  result = result && getDocument(user, "dossier", "livret_famille").etat === 'valide';

                                                result = result && getDocument(user, "dossier", "bail").etat === 'valide';
                                                result = result && getDocument(user, "dossier", "certificat_signature_elec_bail").etat === 'valide';
                                                result = result && getDocument(user, "dossier", "contrat_travail").etat === 'valide';
                                                result = result && getDocument(user, "dossier", "certificat_signature_elec_contrat").etat === 'valide';

                                                if (user.dossier.mute)
                                                  result = result && getDocument(user, "dossier", "avis_mutation").etat === 'valide';

                                                if (user.dossier.mute)
                                                  result = result && getDocument(user, "dossier", "certificat_signature_elec_mutation").etat === 'valide';

                                                if (user.dossier.type_logement_actuel === 'locataire')
                                                  result = result && getDocument(user, "dossier", "quittances_loyer").etat === 'valide';

                                                if (user.dossier.type_logement_actuel === 'proprietaire')
                                                  result = result && getDocument(user, "dossier", "facture_domicile").etat === 'valide';

                                                if (user.dossier.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "dossier", "attestation_hebergement").etat === 'valide';

                                                if (user.dossier.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "dossier", "carte_identite_hebergeur").etat === 'valide';

                                                if (user.dossier.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "dossier", "facture_domicile_hebergeur").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'locataire')
                                                  result = result && getDocument(user, "deuxieme_locataire", "quittances_loyer").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'proprietaire')
                                                  result = result && getDocument(user, "deuxieme_locataire", "facture_domicile").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "deuxieme_locataire", "attestation_hebergement").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "deuxieme_locataire", "carte_identite_hebergeur").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "deuxieme_locataire", "facture_domicile_hebergeur").etat === 'valide';

                                                result = result && getDocument(user, "dossier", "avis_imposition").etat === 'valide';

                                                if (user.dossier.ratache_fiscalement)
                                                  result = result && getDocument(user, "dossier", "attestation_ratachement").etat === 'valide';

                                                if (user.dossier.ratache_fiscalement)
                                                  result = result && getDocument(user, "dossier", "carte_identite_ratacheur").etat === 'valide';

                                                if (user.dossier.ratache_fiscalement)
                                                  result = result && getDocument(user, "dossier", "livret_famille").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire)
                                                  result = result && getDocument(user, "deuxieme_locataire", "avis_imposition").etat === 'valide';

                                                if ((current.roles.role_admin_read || current.roles.role_admin_write))
                                                  result = result && getDocument(user, "dossier", "lettre_mission").etat === 'valide';

                                                return result;
                                              })()}
                                                onClick={() => {
                                                  axios.get(CONFIG.API_URL + '/api/katana_pdf/' + user._id, { responseType: 'blob', headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token'), 'Cache-Control': 'no-cache' } })
                                                    .then((response) => {
                                                      switch (response.status) {
                                                        case 200:
                                                          // create file link in browser's memory
                                                          const href = URL.createObjectURL(response.data);

                                                          // create "a" HTML element with href to file & click
                                                          const link = document.createElement('a');
                                                          link.href = href;
                                                          link.setAttribute('download', user.nom + ' ' + user.prenom); //or any other extension
                                                          document.body.appendChild(link);
                                                          link.click();

                                                          // clean up "a" element & remove ObjectURL
                                                          document.body.removeChild(link);
                                                          URL.revokeObjectURL(href);
                                                          break;

                                                        default:
                                                          break;
                                                      }
                                                    });
                                                }}

                                              >Vérifier le dossier complet</Button>
                                            </div>

                                            <div className='inline-block'>
                                              <Button variant='contained' disabled={!(() => {
                                                var result = true;

                                                result = result && getDocument(user, "dossier", "cerfa").etat === 'valide';
                                                result = result && getDocument(user, "dossier", "certificat_signature_elec_cerfa").etat === 'valide';
                                                result = result && getDocument(user, "dossier", "piece_identite").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire)
                                                  result = result && getDocument(user, "deuxieme_locataire", "piece_identite").etat === 'valide';

                                                if ((current.roles.role_admin_read || current.roles.role_admin_write))
                                                  result = result && getDocument(user, "dossier", "accord_employeur").etat === 'valide';

                                                if (user.dossier.nombre_enfant > 0)
                                                  result = result && getDocument(user, "dossier", "livret_famille").etat === 'valide';

                                                result = result && getDocument(user, "dossier", "bail").etat === 'valide';
                                                result = result && getDocument(user, "dossier", "certificat_signature_elec_bail").etat === 'valide';
                                                result = result && getDocument(user, "dossier", "contrat_travail").etat === 'valide';
                                                result = result && getDocument(user, "dossier", "certificat_signature_elec_contrat").etat === 'valide';

                                                if (user.dossier.mute)
                                                  result = result && getDocument(user, "dossier", "avis_mutation").etat === 'valide';

                                                if (user.dossier.mute)
                                                  result = result && getDocument(user, "dossier", "certificat_signature_elec_mutation").etat === 'valide';

                                                if (user.dossier.type_logement_actuel === 'locataire')
                                                  result = result && getDocument(user, "dossier", "quittances_loyer").etat === 'valide';

                                                if (user.dossier.type_logement_actuel === 'proprietaire')
                                                  result = result && getDocument(user, "dossier", "facture_domicile").etat === 'valide';

                                                if (user.dossier.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "dossier", "attestation_hebergement").etat === 'valide';

                                                if (user.dossier.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "dossier", "carte_identite_hebergeur").etat === 'valide';

                                                if (user.dossier.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "dossier", "facture_domicile_hebergeur").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'locataire')
                                                  result = result && getDocument(user, "deuxieme_locataire", "quittances_loyer").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'proprietaire')
                                                  result = result && getDocument(user, "deuxieme_locataire", "facture_domicile").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "deuxieme_locataire", "attestation_hebergement").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "deuxieme_locataire", "carte_identite_hebergeur").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'heberge')
                                                  result = result && getDocument(user, "deuxieme_locataire", "facture_domicile_hebergeur").etat === 'valide';

                                                result = result && getDocument(user, "dossier", "avis_imposition").etat === 'valide';

                                                if (user.dossier.ratache_fiscalement)
                                                  result = result && getDocument(user, "dossier", "attestation_ratachement").etat === 'valide';

                                                if (user.dossier.ratache_fiscalement)
                                                  result = result && getDocument(user, "dossier", "carte_identite_ratacheur").etat === 'valide';

                                                if (user.dossier.ratache_fiscalement)
                                                  result = result && getDocument(user, "dossier", "livret_famille").etat === 'valide';

                                                if (user.dossier.avec_deuxieme_locataire)
                                                  result = result && getDocument(user, "deuxieme_locataire", "avis_imposition").etat === 'valide';

                                                if ((current.roles.role_admin_read || current.roles.role_admin_write))
                                                  result = result && getDocument(user, "dossier", "lettre_mission").etat === 'valide';

                                                return result;
                                              })()}

                                                onClick={() => {
                                                  axios.post(CONFIG.API_URL + '/api/send_katana_pdf/' + user._id, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token'), 'Cache-Control': 'no-cache' } })
                                                    .then((response) => {
                                                      switch (response.status) {
                                                        case 200:
                                                          openSnackMailOrga();
                                                          setUser(response.data);
                                                          break;

                                                        default:
                                                          break;
                                                      }
                                                    })
                                                    .catch((e) => {
                                                      let response = e.response;

                                                      if (response === undefined) {
                                                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                        return;
                                                      }

                                                      switch (response.status) {
                                                        default:
                                                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                          break;
                                                      }
                                                    });
                                                }}

                                              >Envoyer à l'organisme</Button>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    }
                                  </div>

                                  {currentPage === 5 && currentSubPage === 0 &&
                                    <FicheMetaGroupDocuments
                                      uploadable={true} user={user} setUser={setUser} metaGroupIcon={<FolderIcon fontSize='large'></FolderIcon>} metaGroupName={"Documents locataire n°1"} groupList={
                                        [
                                          {
                                            groupIcon: <AssignmentLateIcon fontSize='large'></AssignmentLateIcon>,
                                            groupName: "Documents",
                                            documentsList: (() => {
                                              var result = [];

                                              result.push({
                                                titre: "Dossier Mobili-Pass",
                                                description: "",
                                                type_dossier: "dossier",
                                                document_name: "cerfa"
                                              });

                                              result.push({
                                                titre: "Certificat de signature électronique du Mobili-Pass",
                                                description: "",
                                                type_dossier: "dossier",
                                                document_name: "certificat_signature_elec_cerfa"
                                              });

                                              result.push({
                                                titre: "Pièce d'identité",
                                                description: "",
                                                type_dossier: "dossier",
                                                document_name: "piece_identite"
                                              });

                                              if (user.dossier.avec_deuxieme_locataire)
                                                result.push({
                                                  titre: "Pièce d'identité du locataire n°2",
                                                  description: "",
                                                  type_dossier: "deuxieme_locataire",
                                                  document_name: "piece_identite"
                                                });

                                              if ((current.roles.role_admin_read || current.roles.role_admin_write))
                                                result.push({
                                                  titre: "Accord employeur",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "accord_employeur"
                                                });

                                              if (user.dossier.nombre_enfant > 0)
                                                result.push({
                                                  titre: "Livret de famille",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "livret_famille"
                                                });

                                              result.push({
                                                titre: "Bail signé par toutes les parties",
                                                description: "",
                                                type_dossier: "dossier",
                                                document_name: "bail"
                                              });

                                              result.push({
                                                titre: "Certificat de signature électronique du bail",
                                                description: "",
                                                type_dossier: "dossier",
                                                document_name: "certificat_signature_elec_bail"
                                              });

                                              result.push({
                                                titre: "Contrat de travail",
                                                description: "",
                                                type_dossier: "dossier",
                                                document_name: "contrat_travail"
                                              });

                                              if (user.dossier.type_contrat === 'alternance')
                                                result.push({
                                                  titre: "Contrat d'alternance (ou attestation/promesse d'emploi de moins d'un mois)",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "contrat_apprentissage",
                                                });

                                              result.push({
                                                titre: "Certificat de signature électronique du contrat",
                                                description: "",
                                                type_dossier: "dossier",
                                                document_name: "certificat_signature_elec_contrat"
                                              });

                                              // result.push({
                                              //   titre: "Mandat de recherche",
                                              //   description: "",
                                              //   type_dossier: "dossier",
                                              //   document_name: "lettre_mission"
                                              // });

                                              if (user.dossier.mute)
                                                result.push({
                                                  titre: "Avis de mutation ou avenant",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "avis_mutation"
                                                });

                                              if (user.dossier.mute)
                                                result.push({
                                                  titre: "Certificat de signature électronique de l'avis de mutation",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "certificat_signature_elec_mutation"
                                                });

                                              if (user.dossier.type_logement_actuel === 'locataire')
                                                result.push({
                                                  titre: "3 Dernières quittance de loyer",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "quittances_loyer"
                                                });

                                              if (user.dossier.type_logement_actuel === 'proprietaire')
                                                result.push({
                                                  titre: "Facture de moins d'un mois",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "facture_domicile"
                                                });

                                              if (user.dossier.type_logement_actuel === 'heberge')
                                                result.push({
                                                  titre: "Attestation d'hébergement",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "attestation_hebergement"
                                                });

                                              if (user.dossier.type_logement_actuel === 'heberge')
                                                result.push({
                                                  titre: "Carte d'identité de l'hébergeur",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "carte_identite_hebergeur"
                                                });

                                              if (user.dossier.type_logement_actuel === 'heberge')
                                                result.push({
                                                  titre: "Facture de l'hébergeur",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "facture_domicile_hebergeur"
                                                });


                                              if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'locataire')
                                                result.push({
                                                  titre: "3 Dernières quittance de loyer locataire n°2",
                                                  description: "",
                                                  type_dossier: "deuxieme_locataire",
                                                  document_name: "quittances_loyer"
                                                });

                                              if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'proprietaire')
                                                result.push({
                                                  titre: "Facture de moins d'un mois locataire n°2",
                                                  description: "",
                                                  type_dossier: "deuxieme_locataire",
                                                  document_name: "facture_domicile"
                                                });

                                              if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'heberge')
                                                result.push({
                                                  titre: "Attestation d'hébergement locataire n°2",
                                                  description: "",
                                                  type_dossier: "deuxieme_locataire",
                                                  document_name: "attestation_hebergement"
                                                });

                                              if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'heberge')
                                                result.push({
                                                  titre: "Carte d'identité de l'hébergeur locataire n°2",
                                                  description: "",
                                                  type_dossier: "deuxieme_locataire",
                                                  document_name: "carte_identite_hebergeur"
                                                });

                                              if (user.dossier.avec_deuxieme_locataire && user.dossier.deuxieme_locataire.type_logement_actuel === 'heberge')
                                                result.push({
                                                  titre: "Facture de l'hébergeur locataire n°2",
                                                  description: "",
                                                  type_dossier: "deuxieme_locataire",
                                                  document_name: "facture_domicile_hebergeur"
                                                });

                                              result.push({
                                                titre: "Avis d'imposition N-1 ou ASDIR",
                                                description: "",
                                                type_dossier: "dossier",
                                                document_name: "avis_imposition"
                                              });

                                              if (user.dossier.ratache_fiscalement)
                                                result.push({
                                                  titre: "Attestation de rattachement fiscal",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "attestation_ratachement"
                                                });

                                              if (user.dossier.ratache_fiscalement)
                                                result.push({
                                                  titre: "Carte d'identité du/des parents",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "carte_identite_ratacheur"
                                                });

                                              if (user.dossier.ratache_fiscalement)
                                                result.push({
                                                  titre: "Livret de famille",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "livret_famille"
                                                });

                                              if (user.dossier.avec_deuxieme_locataire)
                                                result.push({
                                                  titre: "Avis d'imposition N-1 ou ASDIR du locataire n°2",
                                                  description: "",
                                                  type_dossier: "deuxieme_locataire",
                                                  document_name: "avis_imposition"
                                                });

                                              if ((current.roles.role_admin_read || current.roles.role_admin_write))
                                                result.push({
                                                  titre: "Mandat de recherche",
                                                  description: "",
                                                  type_dossier: "dossier",
                                                  document_name: "lettre_mission"
                                                });

                                              return result;
                                            })(),
                                          },
                                        ]
                                      }
                                    />
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      {currentPage === 6 &&
                        <div className='col-span-12 w-full mx-auto shrink-0 bg-gray-50 my-shadow'>
                          <div className='grid grid-cols-12 gap-x-4'>
                            <div className='col-span-12 w-full text-center px-6'>
                              {user.roles.role_client &&
                                <>
                                  <div className='max-w-4xl mx-auto shrink-0'>
                                    <div className='grid grid-cols-12 gap-x-4 m-6'>
                                      <div className='col-span-12 w-full text-center'>
                                        <h1>Archiver</h1>
                                      </div>
                                    </div>

                                    <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 py-6 px-6 bg-white my-shadow'>
                                      <div className='col-span-12 mb-4'>
                                        <h2>Adresse finale</h2>
                                      </div>

                                      <div className='col-span-6 w-full mb-4'>
                                        <WidgetInputText state={montant} setState={setMontant} id={'montant'} text={"Montant versé par l'organisme"} value={user.dossier.montant} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4 grid'>
                                        <WidgetDatePicker state={datePaiementOrganisme} setState={setDatePaiementOrganisme} id={'date_paiement_organisme'} text={"Date du versement organisme"} value={user.dossier.date_paiement_organisme} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4'>
                                        <WidgetInputText state={presta} setState={setPresta} id={'presta'} text={"Montant versé au commercial"} value={user.dossier.presta} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4 grid'>
                                        <WidgetDatePicker state={datePaiementCommercial} setState={setDatePaiementCommercial} id={'date_paiement_commercial'} text={"Date de paiement commercial"} value={user.dossier.date_paiement_commercial} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4 grid'>
                                        <WidgetDatePicker state={datePaiementCodePromo} setState={setDatePaiementCodePromo} id={'date_paiement_code_promo'} text={"Date de paiement code promo"} value={user.dossier.date_paiement_code_promo} />
                                      </div>

                                      <div className='col-span-6 w-full mb-4 grid text-right items-end'>
                                        <div>
                                          <div className='mr-4 inline-block'>
                                            <Button variant='contained' onClick={() => {
                                              const payload = {
                                                montant: montant.value,
                                                presta: presta.value,
                                                date_paiement_organisme: datePaiementOrganisme?.value?.toISOString(),
                                                date_paiement_commercial: datePaiementCommercial?.value?.toISOString(),
                                                date_paiement_code_promo: datePaiementCodePromo?.value?.toISOString()
                                              }

                                              axios.post(CONFIG.API_URL + '/api/set_compta/' + user._id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                                .then((response) => {
                                                  switch (response.status) {
                                                    case 200:
                                                      openSnackMontant();
                                                      break;

                                                    default:
                                                      break;
                                                  }
                                                })
                                                .catch((e) => {
                                                  let response = e.response;

                                                  if (response === undefined) {
                                                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                    return;
                                                  }

                                                  switch (response.status) {
                                                    default:
                                                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                      break;
                                                  }
                                                });
                                            }}>
                                              Mettre à jour
                                            </Button>
                                          </div>
                                          <div className='inline-block'>
                                            <Button variant='contained' onClick={() => {
                                              const payload = {
                                                montant: montant.value,
                                                presta: presta.value,
                                                date_paiement_organisme: datePaiementOrganisme?.value?.toISOString(),
                                                date_paiement_commercial: datePaiementCommercial?.value?.toISOString(),
                                                date_paiement_code_promo: datePaiementCodePromo?.value?.toISOString()
                                              }

                                              axios.post(CONFIG.API_URL + '/api/archiver/' + user._id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                                                .then((response) => {
                                                  switch (response.status) {
                                                    case 200:
                                                      openSnackMontant();
                                                      setUser(response.data);
                                                      window.open(CONFIG.API_URL + '/api/facture/' + user._id)
                                                      break;

                                                    default:
                                                      break;
                                                  }
                                                })
                                                .catch((e) => {
                                                  let response = e.response;

                                                  if (response === undefined) {
                                                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                    return;
                                                  }

                                                  switch (response.status) {
                                                    default:
                                                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                                      break;
                                                  }
                                                });
                                            }}>
                                              Archiver
                                            </Button>
                                          </div>
                                        </div>
                                      </div>


                                      <div className='col-span-4 w-full text-right content-center grid'>
                                        <Button variant='contained' onClick={() => { window.open(CONFIG.API_URL + '/api/facture/' + user._id) }}>
                                          Télécharger la facture
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </>
            }

            {(user.roles.role_commercial || user.roles.role_admin_read || user.roles.role_admin_write || user.roles.role_comptable) &&
              <>
                <hr className='max-w-4xl mx-auto shrink-0 border-gray-400 px-6'></hr>
                <FicheAdmin user={user} setUser={setUser}></FicheAdmin>
              </>
            }

            {(current.roles.role_admin_write) &&
              <>
                <div className='max-w-4xl mx-auto shrink-0'>

                  <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
                    <div className='col-span-12 w-full text-right'>
                      <hr className='w-full border-gray-400 px-6'></hr>
                    </div>
                  </div>

                  <div className='grid grid-cols-10 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
                    <div className='flex col-span-10 w-full mb-1 text-center items-end'>
                      <div className='pr-2 text-ame-gray'>
                        <AddModeratorIcon fontSize='large'></AddModeratorIcon>
                      </div>
                      <div>
                        <h2>Rôles</h2>
                      </div>
                    </div>

                    <div className='col-span-10 w-full mb-4'>
                      <hr></hr>
                    </div>

                    <div className='col-span-2 w-full mb-4'>
                      <WidgetCheckbox state={roleClient} setState={setRoleClient} id={'role_client'} text={"Client"} value={user.roles.role_client} />
                    </div>

                    <div className='col-span-2 w-full mb-4'>
                      <WidgetCheckbox state={roleCommercial} setState={setRoleCommercial} id={'role_commercial'} text={"Commercial"} value={user.roles.role_commercial} />
                    </div>

                    <div className='col-span-2 w-full mb-4'>
                      <WidgetCheckbox state={roleLecture} setState={setRoleLecture} id={'role_comptable'} text={"Lecture admin"} value={user.roles.role_admin_read} />
                    </div>

                    <div className='col-span-2 w-full mb-4'>
                      <WidgetCheckbox state={roleEcriture} setState={setRoleEcriture} id={'role_admin_read'} text={"Ecriture admin"} value={user.roles.role_admin_write} />
                    </div>

                    <div className='col-span-2 w-full mb-4'>
                      <WidgetCheckbox state={roleComptabilite} setState={setRoleComptabilite} id={'role_admin_write'} text={"Comptabilité"} value={user.roles.role_comptable} />
                    </div>
                  </div>

                  <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
                    <div className='col-span-6 w-full text-left'>
                      <Button variant="contained" color={clicked ? "info" : "error"}
                        onClick={() => openAlertDelete(() => {
                          axios.post(CONFIG.API_URL + '/api/client_delete_date/' + user._id, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                            .then((response) => {
                              switch (response.status) {
                                case 200:
                                  setClicked(x => !x);
                                  break;

                                default:
                                  break;
                              }
                            })
                            .catch((e) => {

                            });
                        }, !clicked)}
                      >
                        {!clicked ? "Supprimer le compte" : `Annuler la suppression (J-${days})`}
                      </Button>
                    </div>
                    <div className='col-span-6 w-full text-right'>
                      <Button variant='contained' onClick={() => {
                        let payload = {
                          role_client: roleClient.value,
                          role_commercial: roleCommercial.value,
                          role_comptable: roleLecture.value,
                          role_admin_read: roleEcriture.value,
                          role_admin_write: roleComptabilite.value
                        };

                        axios.post(CONFIG.API_URL + '/api/set_roles/' + user._id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                          .then((response) => {
                            switch (response.status) {
                              case 200:
                                openSnackRole();
                                window.location.reload();
                                break;

                              default:
                                break;
                            }
                          })
                          .catch((e) => {
                            let response = e.response;

                            if (response === undefined) {
                              alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                              return;
                            }

                            switch (response.status) {
                              default:
                                alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                break;
                            }
                          });
                      }}>
                        Mettre à jour les roles
                      </Button>
                    </div>
                  </div>
                </div>
              </>
            }
          </>
        )
      }
    </>
  );
}

export default Fiche;